msgid ""
msgstr ""
"POT-Creation-Date: 2026-07-11 15:05+0000\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: ru\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: file.name
#: src/components/chat/ChatComposer.tsx:1258
msgid "'{0}' exceeds the {FILE_SIZE_LIMIT_LABEL} attachment limit."
msgstr "«{0}» превышает лимит вложения {FILE_SIZE_LIMIT_LABEL}."

#. placeholder {0}: file.name
#: src/components/chat/ChatComposer.tsx:1286
msgid "'{0}' exceeds the {IMAGE_SIZE_LIMIT_LABEL} image preview limit and will be stored as a file."
msgstr "«{0}» превышает лимит предпросмотра изображения {IMAGE_SIZE_LIMIT_LABEL} и будет сохранён как файл."

#: src/components/chat/MessagesTimeline.tsx:412
msgid "(empty response)"
msgstr "(пустой ответ)"

#. placeholder {0}: rows.length + (isAddingBinding ? 1 : 0)
#: src/components/settings/KeybindingsSettings.tsx:1199
msgid "{0, plural, one {# binding} other {# bindings}}"
msgstr "{0, plural, one {# привязка} few {# привязки} many {# привязок} other {# привязки}}"

#. placeholder {0}: scopes.length
#: src/components/settings/ConnectionsSettings.tsx:142
msgid "{0, plural, one {# scope} other {# scopes}}"
msgstr "{0, plural, one {# право} few {# права} many {# прав} other {# права}}"

#. placeholder {0}: attachments.length
#: src/components/chat/AttachmentsBlock.tsx:68
#~ msgid "{0, plural, one {Attached file} other {Attached files}}"
#~ msgstr "{0, plural, one {Прикреплённый файл} few {Прикреплённые файлы} many {Прикреплённые файлы} other {Прикреплённые файлы}}"

#. placeholder {0}: latestProjectThreads.length
#. placeholder {1}: member.name
#. placeholder {2}: member.name
#: src/components/Sidebar.tsx:1108
msgid "{0, plural, one {Remove project \"{1}\" and delete its # thread?} other {Remove project \"{2}\" and delete its # threads?}}"
msgstr "{0, plural, one {Удалить проект «{1}» и его # чат?} few {Удалить проект «{2}» и его # чата?} many {Удалить проект «{2}» и его # чатов?} other {Удалить проект «{2}» и его # чата?}}"

#. placeholder {0}: files.length
#: src/components/DocumentsSidebar.tsx:375
msgid "{0} documents deleted"
msgstr "Документов удалено: {0}"

#. placeholder {0}: files.length
#: src/components/DocumentsSidebar.tsx:455
msgid "{0} files added to materials"
msgstr "Файлов добавлено в материалы: {0}"

#. placeholder {0}: files.length
#: src/components/DocumentsSidebar.tsx:414
msgid "{0} files deleted"
msgstr "Файлов удалено: {0}"

#. placeholder {0}: errorMessageFromUnknown(error)
#: src/components/auth/PairingRouteSurface.tsx:206
msgid "{0} If the backend accepted this one-time token, request a new pairing link before retrying."
msgstr "{0} Если сервер уже принял этот одноразовый токен, запросите новую ссылку для подключения и попробуйте ещё раз."

#. placeholder {0}: activeEnvironmentUnavailableState.label
#. placeholder {0}: environmentUnavailable.label
#: src/components/chat/ChatComposer.tsx:1618
#: src/components/ChatView.tsx:550
msgid "{0} is connecting"
msgstr "{0} подключается"

#. placeholder {0}: activeEnvironmentUnavailableState.label
#. placeholder {0}: environmentUnavailable.label
#: src/components/chat/ChatComposer.tsx:1619
#: src/components/ChatView.tsx:552
msgid "{0} is disconnected"
msgstr "{0} отключён"

#. placeholder {0}: record.label
#: src/components/settings/ConnectionsSettings.tsx:1385
msgid "{0} is now saved and will reconnect on app startup."
msgstr "Окружение {0} сохранено и будет переподключаться при запуске приложения."

#. placeholder {0}: record.label
#: src/components/auth/PairingRouteSurface.tsx:200
msgid "{0} is saved in this browser."
msgstr "{0} сохранён в этом браузере."

#. placeholder {0}: skill.scope
#: src/components/chat/ChatComposer.tsx:575
msgid "{0} skill"
msgstr "Навык {0}"

#: src/components/settings/KeybindingsSettings.tsx:252
msgid "{APP_BASE_NAME} does not recognize this condition yet. It can still be saved, but it may not match unless the runtime provides it."
msgstr "{APP_BASE_NAME} пока не распознаёт это условие. Его можно сохранить, но оно может не сработать, если среда выполнения его не предоставит."

#: src/components/SplashScreen.tsx:11
msgid "{APP_BASE_NAME} splash screen"
msgstr "Заставка {APP_BASE_NAME}"

#: src/components/WebSocketConnectionSurface.tsx:91
msgid "{count, plural, one {# request waiting longer than {thresholdSeconds}s.} other {# requests waiting longer than {thresholdSeconds}s.}}"
msgstr "{count, plural, one {# запрос ожидает дольше {thresholdSeconds} с.} few {# запроса ожидают дольше {thresholdSeconds} с.} many {# запросов ожидают дольше {thresholdSeconds} с.} other {# запроса ожидают дольше {thresholdSeconds} с.}}"

#: src/components/Sidebar.tsx:1284
msgid "{count, plural, one {Delete # thread?} other {Delete # threads?}}"
msgstr "{count, plural, one {Удалить # чат?} few {Удалить # чата?} many {Удалить # чатов?} other {Удалить # чата?}}"

#: src/components/settings/ConnectionsSettings.tsx:1018
msgid "{days, plural, one {# day} other {# days}}"
msgstr "{days, plural, one {# день} few {# дня} many {# дней} other {# дня}}"

#: src/timestampFormat.ts:69
#: src/timestampFormat.ts:96
#: src/timestampFormat.ts:113
#: src/timestampFormat.ts:149
msgid "{days}d"
msgstr "{days}д"

#: src/components/ChatView.tsx:530
msgid "{environmentLabel} server"
msgstr "Сервер {environmentLabel}"

#: src/components/DocumentsSidebar.tsx:702
msgid "{failed, plural, one {# error} other {# errors}}"
msgstr "{failed, plural, one {# ошибка} few {# ошибки} many {# ошибок} other {# ошибки}}"

#: src/components/chat/MessagesTimeline.tsx:878
#: src/components/chat/MessagesTimeline.tsx:878
#: src/timestampFormat.ts:67
#: src/timestampFormat.ts:93
#: src/timestampFormat.ts:111
#: src/timestampFormat.ts:150
msgid "{hours}h"
msgstr "{hours}ч"

#: src/components/settings/DiagnosticsSettings.tsx:100
msgid "{label} details"
msgstr "Сведения о {label}"

#: src/components/ChatView.tsx:456
msgid "{label} is ready."
msgstr "{label} готов."

#: src/components/settings/ConnectionsSettings.tsx:153
msgid "{label}: show {scopeCountLabel}"
msgstr "{label}: показать {scopeCountLabel}"

#: src/components/settings/ConnectionsSettings.tsx:492
msgid "{lastUsedElapsed} ago"
msgstr "{lastUsedElapsed} назад"

#: src/components/settings/ConnectionsSettings.tsx:967
msgid "{maxUses, plural, one {# device} other {# devices}}"
msgstr "{maxUses, plural, one {# устройство} few {# устройства} many {# устройств} other {# устройства}}"

#: src/session-logic.ts:128
#: src/session-logic.ts:132
msgid "{milliseconds}ms"
msgstr "{milliseconds}мс"

#: src/components/chat/MessagesTimeline.tsx:878
#: src/components/chat/MessagesTimeline.tsx:881
#: src/components/chat/MessagesTimeline.tsx:881
#: src/session-logic.ts:145
#: src/session-logic.ts:146
#: src/session-logic.ts:158
#: src/timestampFormat.ts:65
#: src/timestampFormat.ts:90
#: src/timestampFormat.ts:109
#: src/timestampFormat.ts:151
msgid "{minutes}m"
msgstr "{minutes}м"

#: src/session-logic.ts:158
#~ msgid "{padded}s"
#~ msgstr ""

#: src/components/DocumentsSidebar.tsx:698
msgid "{pages, plural, one {# page} other {# pages}}"
msgstr "{pages, plural, one {# стр.} few {# стр.} many {# стр.} other {# стр.}}"

#: src/components/settings/ConnectionsSettings.tsx:961
msgid "{pairingMaxUses, plural, one {# device} other {# devices}}"
msgstr "{pairingMaxUses, plural, one {# устройство} few {# устройства} many {# устройств} other {# устройства}}"

#: src/components/settings/ConnectionsSettings.tsx:978
msgid "{pairingMaxUses, plural, one {The link stops working after # device has paired with it.} other {The link stops working after # devices have paired with it.}}"
msgstr "{pairingMaxUses, plural, one {Ссылка перестаёт работать после подключения # устройства.} few {Ссылка перестаёт работать после подключения # устройств.} many {Ссылка перестаёт работать после подключения # устройств.} other {Ссылка перестаёт работать после подключения # устройств.}}"

#: src/components/settings/ConnectionsSettings.tsx:1009
msgid "{pairingTtlDays, plural, one {# day} other {# days}}"
msgstr "{pairingTtlDays, plural, one {# день} few {# дня} many {# дней} other {# дня}}"

#: src/components/DocumentsSidebar.tsx:700
msgid "{pending} pending"
msgstr "{pending} в ожидании"

#: src/components/chat/MessagesTimeline.tsx:691
msgid "{runningAgents, plural, one {# agent working} other {# agents working}}"
msgstr "{runningAgents, plural, one {работает # агент} few {работает # агента} many {работает # агентов} other {работает # агента}}"

#: src/components/chat/MessagesTimeline.tsx:870
#: src/components/chat/MessagesTimeline.tsx:881
#: src/components/chat/MessagesTimeline.tsx:886
#: src/components/WebSocketConnectionSurface.tsx:42
#: src/session-logic.ts:137
#: src/session-logic.ts:146
#: src/session-logic.ts:155
#: src/session-logic.ts:158
#: src/timestampFormat.ts:87
#: src/timestampFormat.ts:107
#: src/timestampFormat.ts:152
#: src/timestampFormat.ts:153
msgid "{seconds}s"
msgstr "{seconds}с"

#: src/components/DocumentsSidebar.tsx:832
msgid "{selectedCount} selected"
msgstr "Выбрано: {selectedCount}"

#: src/components/chat/MessagesTimeline.tsx:457
#~ msgid "{stageCount, plural, one {# stage} other {# stages}}"
#~ msgstr "{stageCount, plural, one {# этап} few {# этапа} many {# этапов} other {# этапа}}"

#: src/components/DocumentsSidebar.tsx:696
msgid "{total, plural, one {# document} other {# documents}}"
msgstr "{total, plural, one {# документ} few {# документа} many {# документов} other {# документа}}"

#: src/components/settings/ConnectionsSettings.tsx:504
msgid "{useCountLabel} · {lastUsedLabel}"
msgstr "{useCountLabel} · {lastUsedLabel}"

#: src/components/chat/AttachmentsBlock.tsx:106
msgid "+{hiddenCount} more"
msgstr "ещё {hiddenCount}"

#: src/components/chat/MessagesTimeline.tsx:1152
#~ msgid "× {count}"
#~ msgstr "× {count}"

#: src/components/settings/SettingsPanels.tsx:61
msgid "12-hour"
msgstr "12-часовой"

#: src/components/settings/SettingsPanels.tsx:62
msgid "24-hour"
msgstr "24-часовой"

#: src/components/settings/ConnectionsSettings.tsx:525
msgid "A client paired with this link is connected now"
msgstr "Клиент, подключённый по этой ссылке, сейчас в сети"

#: src/components/settings/SettingsPanels.tsx:385
msgid "About"
msgstr "О программе"

#: src/components/CommandPalette.logic.ts:257
msgid "Actions"
msgstr "Действия"

#. placeholder {0}: commandLabel(row.command)
#. placeholder {0}: project.displayName
#. placeholder {0}: thread.title
#: src/components/settings/KeybindingsSettings.tsx:912
#: src/components/Sidebar.tsx:456
#: src/components/Sidebar.tsx:1764
msgid "Actions for {0}"
msgstr "Действия для {0}"

#: src/components/chat/DraftProjectChip.tsx:157
msgid "Add a project to start a chat."
msgstr "Добавьте проект, чтобы начать чат."

#: src/components/settings/ConnectionsSettings.tsx:1601
#: src/components/settings/ConnectionsSettings.tsx:1717
#: src/components/settings/ConnectionsSettings.tsx:1721
#: src/components/settings/ConnectionsSettings.tsx:1729
#: src/routes/_chat.index.tsx:80
msgid "Add environment"
msgstr "Добавить окружение"

#: src/components/settings/ConnectionsSettings.tsx:1735
msgid "Add Environment"
msgstr "Добавить окружение"

#: src/components/settings/KeybindingsSettings.tsx:1226
#: src/components/settings/KeybindingsSettings.tsx:1233
msgid "Add keybinding"
msgstr "Добавить сочетание клавиш"

#: src/components/CommandPalette.tsx:304
msgid "add project"
msgstr "добавить проект"

#: src/components/AddSafeProjectDialog.tsx:168
#: src/components/CommandPalette.tsx:308
msgid "Add project"
msgstr "Добавить проект"

#: src/components/DocumentsSidebar.tsx:660
#: src/components/DocumentsSidebar.tsx:847
msgid "Add to materials"
msgstr "Добавить в материалы"

#. placeholder {0}: fileBasename(files[0]!.path)
#: src/components/DocumentsSidebar.tsx:454
msgid "Added to materials: {0}"
msgstr "Добавлено в материалы: {0}"

#: src/components/AddSafeProjectDialog.tsx:168
#: src/components/settings/ConnectionsSettings.tsx:1601
msgid "Adding…"
msgstr "Добавление…"

#: src/components/settings/ConnectionsSettings.tsx:1690
msgid "Administrative access"
msgstr "Административный доступ"

#: src/components/Sidebar.tsx:1632
msgid "Administrator block"
msgstr "Блокировка администратором"

#: src/components/settings/InspectSettings.tsx:21
#~ msgid "Administrator view"
#~ msgstr "Вид администратора"

#: src/components/settings/CapabilitiesSettings.tsx:207
#: src/components/settings/DiagnosticsSettings.tsx:304
msgid "Agent"
msgstr "Агент"

#: src/components/SubAgentPanel.tsx:46
msgid "Agent task"
msgstr "Задача агента"

#: src/components/chat/SubAgentsHeaderButton.tsx:24
#: src/components/SubAgentPanel.tsx:85
msgid "Agents"
msgstr "Агенты"

#: src/timestampFormat.ts:65
#: src/timestampFormat.ts:67
#: src/timestampFormat.ts:69
msgid "ago"
msgstr "назад"

#: src/hooks/useVoiceInput.ts:126
msgid "Allow the microphone for this site in the browser settings, then press the microphone again."
msgstr "Разрешите доступ к микрофону для этого сайта в настройках браузера и нажмите микрофон ещё раз."

#: src/components/settings/KeybindingsSettings.tsx:673
#: src/components/settings/KeybindingsSettings.tsx:887
#: src/components/settings/KeybindingsSettings.tsx:1049
msgid "Always"
msgstr "Всегда"

#: src/components/AddSafeProjectDialog.tsx:131
#: src/components/DocumentsSidebar.tsx:294
#: src/components/settings/SettingsPanels.tsx:478
#: src/components/settings/SettingsPanels.tsx:562
#: src/components/Sidebar.tsx:756
#: src/components/Sidebar.tsx:776
#: src/components/Sidebar.tsx:796
#: src/components/Sidebar.tsx:1443
#: src/components/Sidebar.tsx:1497
#: src/components/Sidebar.tsx:1555
#: src/components/Sidebar.tsx:1642
msgid "An error occurred."
msgstr "Произошла ошибка."

#: src/components/CommandPalette.tsx:364
msgid "An unexpected error occurred."
msgstr "Произошла непредвиденная ошибка."

#: src/routes/__root.tsx:236
msgid "An unexpected router error occurred."
msgstr "Произошла непредвиденная ошибка маршрутизатора."

#: src/components/settings/ConnectionsSettings.tsx:251
msgid "An unknown connection error occurred."
msgstr "Произошла неизвестная ошибка подключения."

#: src/components/chat/MessagesTimeline.tsx:1182
msgid "and {more} more"
msgstr "и ещё {more}"

#: src/components/settings/ConnectionsSettings.tsx:960
#: src/components/settings/ConnectionsSettings.tsx:971
msgid "Any number of devices"
msgstr "Любое число устройств"

#: src/components/chat/MessagesTimeline.tsx:946
msgid "Approval resolved"
msgstr "Запрос обработан"

#: src/components/settings/DiagnosticsSettings.tsx:1019
msgid "Approximate active CPU time for the T3 server root process and its descendants during the selected window. It grows only while sampled processes use CPU and older samples leave as the window moves."
msgstr "Приблизительное активное время ЦП корневого процесса сервера T3 и его потомков за выбранный период. Оно растёт только пока измеряемые процессы используют ЦП, а старые замеры выбывают по мере сдвига окна."

#: src/components/settings/settingsNavItems.ts:47
#: src/components/Sidebar.tsx:1588
msgid "Archive"
msgstr "Архивировать"

#: src/components/settings/SettingsPanels.tsx:336
msgid "archive confirmation"
msgstr "подтверждение архивирования"

#: src/components/settings/SettingsPanels.tsx:139
#: src/components/settings/SettingsPanels.tsx:331
msgid "Archive confirmation"
msgstr "Подтверждение архивирования"

#. placeholder {0}: thread.title
#: src/components/Sidebar.tsx:1650
msgid "Archive thread \"{0}\"?"
msgstr "Архивировать чат «{0}»?"

#. placeholder {0}: formatRelativeTimeLabel(thread.archivedAt ?? thread.createdAt)
#. placeholder {1}: formatRelativeTimeLabel(thread.createdAt)
#: src/components/settings/SettingsPanels.tsx:541
msgid "Archived {0} · Created {1}"
msgstr "Архивировано {0} · Создано {1}"

#: src/components/settings/SettingsPanels.tsx:496
msgid "Archived threads"
msgstr "Архивированные чаты"

#: src/components/settings/SettingsPanels.tsx:515
msgid "Archived threads will appear here."
msgstr "Архивированные чаты появятся здесь."

#: src/components/chat/MessagesTimeline.tsx:1501
msgid "Arguments"
msgstr "Аргументы"

#: src/components/settings/SettingsPanels.tsx:358
msgid "Ask before deleting a thread and its chat history."
msgstr "Спрашивать перед удалением чата и его истории."

#: src/components/chat/ChatComposer.tsx:227
#: src/components/chat/ChatComposer.tsx:233
msgid "Attach files"
msgstr "Прикрепить файлы"

#: src/components/DocumentsSidebar.tsx:738
msgid "Attach files in the chat to add them."
msgstr "Прикрепите файлы в чате, чтобы добавить их в проект."

#. placeholder {0}: status.reconnectMaxAttempts
#: src/components/WebSocketConnectionSurface.tsx:50
msgid "Attempt {reconnectAttempt}/{0}"
msgstr "Попытка {reconnectAttempt}/{0}"

#: src/components/auth/PairingRouteSurface.tsx:293
msgid "Authentication failed."
msgstr "Ошибка аутентификации."

#: src/environments/primary/auth.ts:188
msgid "Authentication required."
msgstr "Требуется аутентификация."

#: src/components/settings/ConnectionsSettings.tsx:1680
msgid "Authorized clients"
msgstr "Авторизованные клиенты"

#: src/components/settings/SettingsPanels.tsx:310
msgid "auto-open task panel"
msgstr "автооткрытие панели задач"

#: src/components/settings/SettingsPanels.tsx:136
#: src/components/settings/SettingsPanels.tsx:305
msgid "Auto-open task panel"
msgstr "Автооткрытие панели задач"

#: src/components/Sidebar.tsx:1747
msgid "Available in multiple environments"
msgstr "Доступно в нескольких окружениях"

#: src/components/settings/DiagnosticsSettings.tsx:724
#: src/components/settings/DiagnosticsSettings.tsx:1290
msgid "Average"
msgstr "Среднее"

#. placeholder {0}: bucket.avgCpuPercent.toFixed(1)
#. placeholder {1}: bucket.maxCpuPercent.toFixed(1)
#: src/components/settings/DiagnosticsSettings.tsx:629
msgid "Average CPU {0}%, peak CPU {1}%"
msgstr "Среднее ЦП {0}%, пик ЦП {1}%"

#. placeholder {0}: bucket.avgCpuPercent.toFixed(1)
#. placeholder {1}: bucket.maxCpuPercent.toFixed(1)
#: src/components/settings/DiagnosticsSettings.tsx:644
msgid "Avg {0}%, peak {1}%"
msgstr "Сред. {0}%, пик {1}%"

#: src/components/CommandPalette.tsx:405
#: src/components/CommandPalette.tsx:447
#: src/components/settings/SettingsSidebarNav.tsx:94
msgid "Back"
msgstr "Назад"

#: src/components/settings/ConnectionsSettings.tsx:1384
msgid "Backend added"
msgstr "Сервер добавлен"

#: src/components/auth/PairingRouteSurface.tsx:237
msgid "Backend paired"
msgstr "Сервер подключён"

#: src/components/Sidebar.tsx:1584
msgid "Block chat"
msgstr "Заблокировать чат"

#: src/components/AddSafeProjectDialog.tsx:165
#: src/components/chat/ChatComposer.tsx:1717
#: src/components/DocumentsSidebar.tsx:873
#: src/components/settings/ConnectionsSettings.tsx:1038
#: src/components/settings/KeybindingsSettings.tsx:1081
#: src/components/Sidebar.tsx:1847
msgid "Cancel"
msgstr "Отмена"

#: src/components/settings/KeybindingsSettings.tsx:1073
msgid "Cancel new keybinding"
msgstr "Отменить новое сочетание клавиш"

#: src/components/chat/ComposerVoiceRecordingBar.tsx:28
msgid "Cancel recording"
msgstr "Отменить запись"

#: src/components/chat/ComposerVoiceRecordingBar.tsx:30
msgid "Cancel transcription"
msgstr "Отменить распознавание"

#: src/components/settings/settingsNavItems.ts:36
msgid "Capabilities"
msgstr "Возможности"

#: src/components/settings/CapabilitiesSettings.tsx:171
msgid "Capabilities are pinned by the <0>T3CODE_FEATURE_FLAGS</0> override of this dev run; the flag files take over once the override is removed."
msgstr "Возможности зафиксированы переопределением <0>T3CODE_FEATURE_FLAGS</0> этого dev-запуска; файлы флагов вступят в силу после снятия переопределения."

#: src/components/settings/DiagnosticsSettings.tsx:1129
#: src/components/settings/DiagnosticsSettings.tsx:1157
msgid "Cause"
msgstr "Причина"

#: src/components/chat/DraftProjectChip.tsx:114
msgid "Change project"
msgstr "Сменить проект"

#: src/components/chat/DraftProjectChip.tsx:101
msgid "Change the project for this draft"
msgstr "Сменить проект для этого черновика"

#: src/components/chat/MessagesTimeline.tsx:930
msgid "Changed files"
msgstr "Изменение файлов"

#: src/components/chat/MessagesTimeline.tsx:1375
msgid "Changes"
msgstr "Изменения"

#: src/components/CommandPalette.tsx:270
msgid "chat"
msgstr "чат"

#: src/components/chat/ComposerPrimaryActions.tsx:86
#: src/components/ThreadStatusIndicators.tsx:85
msgid "Chat blocked"
msgstr "Чат заблокирован"

#: src/components/Sidebar.tsx:1633
msgid "Chat blocked by an administrator."
msgstr "Чат заблокирован администратором."

#: src/components/chat/ThreadBlockedNotice.tsx:26
msgid "Chat blocked. <0>Reason</0>."
msgstr "Чат заблокирован. <0>Причина</0>."

#: src/components/settings/KeybindingsSettings.logic.ts:273
msgid "Chat: New"
msgstr "Чат: новый"

#: src/components/settings/KeybindingsSettings.logic.ts:275
msgid "Chat: New Local"
msgstr "Чат: новый локальный"

#: src/hooks/useVoiceInput.ts:131
msgid "Check that a microphone is connected and not used by another application."
msgstr "Проверьте, что микрофон подключён и не занят другим приложением."

#. placeholder {0}: relative.value
#: src/components/settings/DiagnosticsSettings.tsx:818
msgid "Checked {0}"
msgstr "Проверено {0}"

#. placeholder {0}: relative.value
#. placeholder {1}: relative.suffix
#: src/components/settings/DiagnosticsSettings.tsx:814
msgid "Checked <0>{0}</0> {1}"
msgstr "Проверено <0>{0}</0> {1}"

#: src/components/settings/DiagnosticsSettings.tsx:806
msgid "Checking"
msgstr "Проверка"

#: src/components/settings/SettingsPanels.tsx:514
msgid "Checking connected environments."
msgstr "Проверка подключённых окружений."

#: src/components/settings/DiagnosticsSettings.tsx:580
msgid "Child process {name}"
msgstr "Дочерний процесс {name}"

#: src/components/settings/DiagnosticsSettings.tsx:952
msgid "Child Processes"
msgstr "Дочерние процессы"

#: src/components/CommandPalette.tsx:292
msgid "choose"
msgstr "выбрать"

#: src/components/chat/DraftProjectChip.tsx:99
msgid "Choose a project"
msgstr "Выберите проект"

#: src/components/settings/SettingsPanels.tsx:196
msgid "Choose how {APP_BASE_NAME} looks across the app."
msgstr "Выберите, как {APP_BASE_NAME} выглядит во всём приложении."

#: src/components/settings/ConnectionsSettings.tsx:1275
msgid "Click “Add environment” to pair another environment."
msgstr "Нажмите «Добавить окружение», чтобы подключить новое окружение."

#. placeholder {0}: versionMismatch.clientVersion
#. placeholder {1}: versionMismatch.serverVersion
#: src/components/ChatView.tsx:595
msgid "Client {0} is connected to {versionMismatchServerLabel} {1}. Sync them if RPC calls or reconnects fail."
msgstr "Клиент {0} подключён к {versionMismatchServerLabel} {1}. Синхронизируйте их, если вызовы RPC или переподключения не удаются."

#. placeholder {0}: primaryVersionMismatch.clientVersion
#. placeholder {1}: primaryVersionMismatch.serverVersion
#: src/components/settings/ConnectionsSettings.tsx:1666
msgid "Client {0}, server {1}. Sync them if RPC calls or reconnects fail."
msgstr "Клиент {0}, сервер {1}. Синхронизируйте их, если RPC-вызовы или переподключения не работают."

#: src/components/ChatView.tsx:593
msgid "Client and server versions differ"
msgstr "Версии клиента и сервера различаются"

#: src/components/settings/ConnectionsSettings.tsx:866
msgid "Client label (optional)"
msgstr "Метка клиента (необязательно)"

#: src/components/settings/ConnectionsSettings.tsx:761
msgid "Client scopes"
msgstr "Права клиента"

#: src/components/settings/ConnectionsSettings.tsx:635
msgid "Clipboard copy is unavailable here. Manually copy this code into another client."
msgstr "Копирование в буфер обмена здесь недоступно. Скопируйте этот код в другой клиент вручную."

#: src/components/settings/ConnectionsSettings.tsx:630
msgid "Clipboard copy is unavailable here. Open or manually copy this full pairing URL on the device you want to connect."
msgstr "Копирование в буфер обмена здесь недоступно. Откройте или скопируйте вручную этот полный URL подключения на устройстве, которое хотите подключить."

#: src/components/settings/ConnectionsSettings.tsx:452
msgid "Clipboard copy unavailable"
msgstr "Копирование в буфер обмена недоступно"

#: src/components/CommandPalette.tsx:307
#~ msgid "clone"
#~ msgstr "клонировать"

#: src/components/chat/BasaDocumentDialog.tsx:225
#: src/components/chat/ThreadBlockedNotice.tsx:46
#: src/components/CommandPalette.tsx:454
#: src/components/ui/dialog.tsx:81
#: src/components/ui/sheet.tsx:101
msgid "Close"
msgstr "Закрыть"

#. placeholder {0}: label.toLowerCase()
#: src/components/PlanSidebar.tsx:78
msgid "Close {0} sidebar"
msgstr "Закрыть боковую панель {0}"

#: src/components/DocumentsSidebar.tsx:809
msgid "Close documents panel"
msgstr "Закрыть панель документов"

#: src/components/chat/ExpandedImageDialog.tsx:71
#: src/components/chat/ExpandedImageDialog.tsx:93
msgid "Close image preview"
msgstr "Закрыть предпросмотр изображения"

#: src/components/settings/CapabilitiesSettings.tsx:227
msgid "Codex model every turn runs with."
msgstr "Модель Codex, с которой выполняется каждый ход."

#: src/components/settings/DiagnosticsSettings.tsx:331
msgid "Collapse {name}"
msgstr "Свернуть {name}"

#: src/components/ChatMarkdown.tsx:259
msgid "Collapse table cells"
msgstr "Свернуть ячейки таблицы"

#: src/components/settings/DiagnosticsSettings.tsx:1056
msgid "Collecting process resource samples..."
msgstr "Сбор замеров ресурсов процессов..."

#: src/components/chat/MessagesTimeline.tsx:1494
#: src/components/settings/DiagnosticsSettings.tsx:477
#: src/components/settings/DiagnosticsSettings.tsx:733
#: src/components/settings/KeybindingsSettings.tsx:1002
#: src/components/settings/KeybindingsSettings.tsx:1256
msgid "Command"
msgstr "Команда"

#: src/components/chat/MessagesTimeline.tsx:943
msgid "Command approval requested"
msgstr "Запрошено одобрение команды"

#: src/components/CommandPalette.tsx:372
#: src/components/CommandPalette.tsx:385
msgid "Command palette"
msgstr "Палитра команд"

#: src/components/settings/KeybindingsSettings.logic.ts:271
msgid "Command Palette: Toggle"
msgstr "Палитра команд: переключить"

#: src/components/chat/MessagesTimeline.tsx:928
msgid "Command run"
msgstr "Запуск команды"

#: src/components/settings/InspectSettings.tsx:24
#~ msgid "Commands, arguments, results and diffs behind each step, developer-only steps and provider warnings. Off, the chat reads exactly as a user sees it."
#~ msgstr "Команды, аргументы, результаты и диффы за каждым шагом, служебные шаги и предупреждения провайдера. Выключено: чат выглядит так же, как у пользователя."

#: src/components/settings/InspectSettings.tsx:24
#~ msgid "Commands, arguments, results and diffs behind each step, expandable per row. Off, every step reads as a user sees it."
#~ msgstr "Команды, аргументы, результаты и диффы за каждым шагом, раскрываются построчно. Выключено: каждый шаг выглядит так же, как у пользователя."

#: src/components/settings/InspectSettings.tsx:24
msgid "Commands, arguments, results and diffs of steps, developer-only steps, provider warnings and model parameters."
msgstr "Команды, аргументы, результаты и диффы шагов, служебные шаги, предупреждения провайдера и параметры модели."

#: src/components/settings/ConnectionsSettings.tsx:133
#~ msgid "Commands, arguments, results, and diffs of agent tool calls."
#~ msgstr "Команды, аргументы, результаты, диффы."

#: src/components/chat/MessagesTimeline.tsx:953
msgid "Compacting context…"
msgstr "Сжимаю контекст…"

#: src/components/Sidebar.logic.ts:38
msgid "Completed"
msgstr "Завершено"

#: src/components/settings/KeybindingsSettings.tsx:314
#: src/components/settings/KeybindingsSettings.tsx:536
#: src/components/settings/KeybindingsSettings.tsx:653
#: src/components/settings/KeybindingsSettings.tsx:709
msgid "Condition"
msgstr "Условие"

#: src/components/CommandPalette.tsx:318
msgid "configuration"
msgstr "конфигурация"

#: src/components/settings/SettingsPanels.tsx:351
msgid "Confirm thread archiving"
msgstr "Подтверждать архивирование чата"

#: src/components/settings/SettingsPanels.tsx:377
msgid "Confirm thread deletion"
msgstr "Подтверждать удаление чата"

#. placeholder {0}: labels.slice(0, 3).join(", ")
#: src/components/settings/KeybindingsSettings.tsx:268
msgid "Conflicts with {0}, and more."
msgstr "Конфликтует с {0} и другими."

#. placeholder {0}: labels.join(", ")
#. placeholder {0}: labels[0]
#: src/components/settings/KeybindingsSettings.tsx:266
#: src/components/settings/KeybindingsSettings.tsx:269
msgid "Conflicts with {0}."
msgstr "Конфликтует с {0}."

#: src/components/settings/ConnectionsSettings.tsx:1243
msgid "Connect"
msgstr "Подключить"

#: src/routes/_chat.index.tsx:69
msgid "Connect an environment to get started"
msgstr "Подключите окружение, чтобы начать"

#: src/components/settings/ConnectionsSettings.tsx:715
msgid "Connected"
msgstr "Подключено"

#. placeholder {0}: formatElapsedDurationLabel(connectedAt, nowMs)
#. placeholder {0}: formatElapsedDurationLabel(lastConnectedAt, nowMs)
#: src/components/settings/ConnectionsSettings.tsx:243
#: src/components/settings/ConnectionsSettings.tsx:714
msgid "Connected for {0}"
msgstr "Подключено {0}"

#: src/components/chat/ComposerPrimaryActions.tsx:90
#: src/components/Sidebar.logic.ts:37
msgid "Connecting"
msgstr "Подключение"

#: src/components/auth/PairingRouteSurface.tsx:164
#: src/components/auth/PairingRouteSurface.tsx:189
msgid "Connecting to this backend."
msgstr "Подключение к этому серверу."

#: src/components/settings/ConnectionsSettings.tsx:1241
msgid "Connecting…"
msgstr "Подключение…"

#: src/components/WebSocketConnectionSurface.tsx:81
msgid "Connection restored at {reconnectedAtLabel}."
msgstr "Соединение восстановлено в {reconnectedAtLabel}."

#: src/components/WebSocketConnectionSurface.tsx:84
msgid "Connection restored."
msgstr "Соединение восстановлено."

#: src/components/ChatView.tsx:582
#: src/components/settings/settingsNavItems.ts:33
msgid "Connections"
msgstr "Подключения"

#: src/components/chat/ProviderStatusBanner.tsx:38
msgid "Contact your administrator if this persists."
msgstr "Если проблема не исчезнет, обратитесь к администратору."

#: src/components/chat/MessagesTimeline.tsx:952
msgid "Context compacted"
msgstr "Контекст сжат"

#: src/components/chat/MessagesTimeline.tsx:954
msgid "Context compaction failed"
msgstr "Не удалось сжать контекст"

#: src/components/chat/ContextWindowMeter.tsx:82
msgid "Context Window"
msgstr "Окно контекста"

#. placeholder {0}: formatContextWindowTokens(usage.usedTokens)
#: src/components/chat/ContextWindowMeter.tsx:44
msgid "Context window {0} tokens used"
msgstr "Использовано токенов окна контекста: {0}"

#: src/components/chat/ContextWindowMeter.tsx:43
msgid "Context window {usedPercentage} used"
msgstr "Окно контекста использовано на {usedPercentage}"

#: src/components/chat/ContextWindowMeter.tsx:106
msgid "Context window usage"
msgstr "Использование окна контекста"

#: src/components/auth/PairingRouteSurface.tsx:138
msgid "Continue"
msgstr "Продолжить"

#: src/components/ChatMarkdown.tsx:260
#: src/components/ChatMarkdown.tsx:505
#: src/components/settings/DiagnosticsSettings.tsx:287
msgid "Copied"
msgstr "Скопировано"

#: src/components/settings/DiagnosticsSettings.tsx:279
msgid "Copied trace ID"
msgstr "ID трейса скопирован"

#: src/components/chat/MessageCopyButton.tsx:22
msgid "Copied!"
msgstr "Скопировано!"

#: src/components/DocumentsSidebar.tsx:518
msgid "copy"
msgstr "копия"

#: src/components/ChatMarkdown.tsx:381
msgid "Copy as CSV"
msgstr "Копировать как CSV"

#: src/components/ChatMarkdown.tsx:378
msgid "Copy as Markdown"
msgstr "Копировать как Markdown"

#: src/components/ChatMarkdown.tsx:505
#: src/components/settings/ConnectionsSettings.tsx:509
#: src/components/settings/ConnectionsSettings.tsx:614
#: src/components/settings/ConnectionsSettings.tsx:669
msgid "Copy code"
msgstr "Копировать код"

#: src/components/settings/DiagnosticsSettings.tsx:287
msgid "Copy full trace ID"
msgstr "Копировать полный ID трейса"

#: src/components/chat/MessageCopyButton.tsx:67
msgid "Copy link"
msgstr "Копировать ссылку"

#: src/components/Sidebar.tsx:1577
msgid "Copy Link"
msgstr "Копировать ссылку"

#: src/components/settings/ConnectionsSettings.tsx:590
msgid "Copy pairing link"
msgstr "Копировать ссылку для подключения"

#: src/components/settings/ConnectionsSettings.tsx:592
msgid "Copy pairing URL"
msgstr "Копировать URL подключения"

#: src/components/Sidebar.tsx:1389
msgid "Copy Path"
msgstr "Копировать путь"

#: src/components/ChatMarkdown.tsx:260
msgid "Copy table"
msgstr "Копировать таблицу"

#: src/components/chat/BasaDocumentDialog.tsx:219
msgid "Copy text"
msgstr "Копировать текст"

#: src/components/settings/ConnectionsSettings.tsx:578
msgid "Copy the token and pair from another client using this backend's reachable host."
msgstr "Скопируйте токен и подключитесь из другого клиента по доступному адресу этого сервера."

#: src/components/Sidebar.tsx:1578
msgid "Copy Thread ID"
msgstr "Копировать ID чата"

#: src/components/chat/MessageCopyButton.tsx:82
msgid "Copy to clipboard"
msgstr "Копировать в буфер обмена"

#: src/components/settings/DiagnosticsSettings.tsx:279
msgid "Copy trace ID"
msgstr "Копировать ID трейса"

#: src/components/settings/UsageSettings.tsx:123
msgid "Cost"
msgstr "Стоимость"

#. placeholder {0}: failures.length
#. placeholder {1}: files.length
#: src/components/DocumentsSidebar.tsx:461
msgid "Could not add {0} of {1} files to materials"
msgstr "Не удалось добавить в материалы {0} из {1} файлов"

#: src/components/settings/ConnectionsSettings.tsx:1393
msgid "Could not add backend"
msgstr "Не удалось добавить сервер"

#: src/components/settings/ConnectionsSettings.tsx:1414
msgid "Could not connect backend"
msgstr "Не удалось подключить сервер"

#: src/components/settings/ConnectionsSettings.tsx:451
msgid "Could not copy pairing code"
msgstr "Не удалось скопировать код подключения"

#: src/components/settings/ConnectionsSettings.tsx:450
msgid "Could not copy pairing URL"
msgstr "Не удалось скопировать URL подключения"

#: src/components/settings/ConnectionsSettings.tsx:815
msgid "Could not create pairing URL"
msgstr "Не удалось создать URL подключения"

#. placeholder {0}: failures.length
#. placeholder {1}: files.length
#: src/components/DocumentsSidebar.tsx:381
msgid "Could not delete {0} of {1} documents"
msgstr "Не удалось удалить {0} из {1} документов"

#. placeholder {0}: failures.length
#. placeholder {1}: files.length
#: src/components/DocumentsSidebar.tsx:420
msgid "Could not delete {0} of {1} files"
msgstr "Не удалось удалить {0} из {1} файлов"

#: src/components/settings/ConnectionsSettings.tsx:1437
msgid "Could not disconnect backend"
msgstr "Не удалось отключить сервер"

#: src/components/settings/SettingsPanels.tsx:508
msgid "Could not load archived threads"
msgstr "Не удалось загрузить архивированные чаты"

#: src/components/chat/BasaDocumentDialog.tsx:207
msgid "Could not load the document."
msgstr "Не удалось загрузить документ."

#: src/components/ChatView.tsx:462
msgid "Could not reconnect environment"
msgstr "Не удалось переподключить окружение"

#: src/components/settings/ConnectionsSettings.tsx:1460
msgid "Could not remove backend"
msgstr "Не удалось удалить сервер"

#: src/components/settings/ConnectionsSettings.tsx:1356
msgid "Could not revoke client access"
msgstr "Не удалось отозвать доступ клиента"

#: src/components/settings/ConnectionsSettings.tsx:1333
msgid "Could not revoke pairing link"
msgstr "Не удалось отозвать ссылку для подключения"

#: src/components/settings/DiagnosticsSettings.tsx:907
#: src/components/settings/DiagnosticsSettings.tsx:917
msgid "Could not send {signal}"
msgstr "Не удалось отправить {signal}"

#: src/components/chat/ChatComposer.tsx:1119
msgid "Could not transcribe the audio"
msgstr "Не удалось распознать аудио"

#: src/components/settings/DiagnosticsSettings.tsx:1157
#: src/components/settings/DiagnosticsSettings.tsx:1290
msgid "Count"
msgstr "Количество"

#: src/components/settings/DiagnosticsSettings.tsx:471
#: src/components/settings/DiagnosticsSettings.tsx:956
msgid "CPU"
msgstr "ЦП"

#: src/components/settings/DiagnosticsSettings.tsx:718
#: src/components/settings/DiagnosticsSettings.tsx:1017
msgid "CPU Time"
msgstr "Время ЦП"

#: src/components/CommandPalette.tsx:270
msgid "create"
msgstr "создать"

#: src/components/settings/ConnectionsSettings.tsx:117
msgid "Create comments while reviewing changes."
msgstr "Создавайте комментарии при просмотре изменений."

#: src/components/settings/ConnectionsSettings.tsx:848
#: src/components/settings/ConnectionsSettings.tsx:1044
msgid "Create link"
msgstr "Создать ссылку"

#: src/components/settings/ConnectionsSettings.tsx:855
msgid "Create pairing link"
msgstr "Создать ссылку для подключения"

#: src/components/DocumentsSidebar.tsx:789
msgid "Created"
msgstr "Созданные"

#: src/components/Sidebar.tsx:174
#: src/components/Sidebar.tsx:179
msgid "Created at"
msgstr "Дата создания"

#: src/components/settings/ConnectionsSettings.tsx:1044
msgid "Creating…"
msgstr "Создание…"

#: src/components/settings/DiagnosticsSettings.tsx:721
msgid "Current"
msgstr "Текущий"

#: src/components/CommandPalette.logic.ts:116
msgid "Current thread"
msgstr "Текущий чат"

#: src/components/settings/SettingsPanels.tsx:83
msgid "Current version of the application."
msgstr "Текущая версия приложения."

#: src/components/settings/SettingsPanels.tsx:55
msgid "Dark"
msgstr "Тёмная"

#: src/components/Sidebar.tsx:1994
msgid "Decrease visible thread count"
msgstr "Уменьшить число видимых чатов"

#: src/components/chat/ChatComposer.tsx:161
#: src/components/chat/CompactComposerControlsMenu.tsx:33
#: src/components/settings/CapabilitiesSettings.tsx:53
msgid "Deep Work"
msgstr "Deep Work"

#: src/components/chat/ChatComposer.tsx:135
msgid "Deep Work disabled — click to enable"
msgstr "Deep Work выключен — нажмите, чтобы включить"

#: src/components/chat/ChatComposer.tsx:134
msgid "Deep Work enabled — click to disable"
msgstr "Deep Work включён — нажмите, чтобы выключить"

#: src/components/chat/ChatComposer.tsx:1709
msgid "Deep Work mode searches and analyzes materials more thoroughly. It is recommended for the most complex tasks and can take a long time."
msgstr "Режим Deep Work позволяет более тщательно производить поиск и анализировать материалы. Этот режим рекомендуется для самых сложных задач и может занимать продолжительное время."

#: src/components/settings/CapabilitiesSettings.tsx:54
msgid "Deep Work toggle in the composer."
msgstr "Переключатель Deep Work в композере."

#: src/components/DocumentsSidebar.tsx:663
#: src/components/DocumentsSidebar.tsx:865
#: src/components/settings/SettingsPanels.tsx:464
#: src/components/Sidebar.tsx:1589
msgid "Delete"
msgstr "Удалить"

#. placeholder {0}: files[0]?.path
#: src/components/DocumentsSidebar.tsx:355
msgid "Delete \"{0}\" from materials? The agent will no longer see it."
msgstr "Удалить «{0}» из материалов? Агент больше не будет видеть этот файл."

#. placeholder {0}: files[0]?.path
#: src/components/DocumentsSidebar.tsx:398
msgid "Delete \"{0}\"? This cannot be undone."
msgstr "Удалить «{0}»? Это действие нельзя отменить."

#. placeholder {0}: files.length
#: src/components/DocumentsSidebar.tsx:356
msgid "Delete {0} files from materials? The agent will no longer see them."
msgstr "Удалить выбранные файлы ({0}) из материалов? Агент больше не будет их видеть."

#. placeholder {0}: files.length
#: src/components/DocumentsSidebar.tsx:399
msgid "Delete {0} files? This cannot be undone."
msgstr "Удалить выбранные файлы ({0})? Это действие нельзя отменить."

#: src/components/Sidebar.tsx:1090
msgid "Delete all threads in this project before removing it."
msgstr "Удалите все чаты в этом проекте перед его удалением."

#: src/components/Sidebar.tsx:1093
msgid "Delete anyway"
msgstr "Всё равно удалить"

#: src/components/settings/SettingsPanels.tsx:362
msgid "delete confirmation"
msgstr "подтверждение удаления"

#: src/components/settings/SettingsPanels.tsx:142
#: src/components/settings/SettingsPanels.tsx:357
msgid "Delete confirmation"
msgstr "Подтверждение удаления"

#: src/components/DocumentsSidebar.tsx:599
msgid "Delete from materials"
msgstr "Удалить из материалов"

#: src/components/chat/ComposerVoiceRecordingBar.tsx:31
msgid "Delete recording"
msgstr "Удалить запись"

#. placeholder {0}: thread.title
#: src/components/Sidebar.tsx:1660
msgid "Delete thread \"{0}\"?"
msgstr "Удалить чат «{0}»?"

#: src/components/chat/ChatComposer.tsx:1544
#: src/components/chat/ChatComposer.tsx:1620
msgid "Describe a task or ask a question"
msgstr "Опишите задачу или задайте вопрос"

#: src/components/chat/MessagesTimeline.tsx:1525
msgid "Details"
msgstr "Подробности"

#: src/components/settings/InspectSettings.tsx:21
msgid "Developer settings"
msgstr "Настройки разработчика"

#: src/components/settings/ConnectionsSettings.tsx:941
#: src/components/settings/ConnectionsSettings.tsx:955
msgid "Devices"
msgstr "Устройства"

#: src/components/settings/settingsNavItems.ts:42
msgid "Diagnostics"
msgstr "Диагностика"

#: src/components/CommandPalette.tsx:306
msgid "directory"
msgstr "каталог"

#: src/components/ChatMarkdown.tsx:504
msgid "Disable line wrap"
msgstr "Отключить перенос строк"

#: src/components/settings/ConnectionsSettings.tsx:1238
msgid "Disconnect"
msgstr "Отключить"

#: src/components/WebSocketConnectionSurface.tsx:77
msgid "Disconnected at {disconnectedAtLabel} and reconnected at {reconnectedAtLabel}."
msgstr "Отключено в {disconnectedAtLabel} и переподключено в {reconnectedAtLabel}."

#. placeholder {0}: getConnectionDisplayName(status)
#: src/components/WebSocketConnectionSurface.tsx:62
msgid "Disconnected from {0}"
msgstr "Отключено от {0}"

#: src/components/settings/ConnectionsSettings.tsx:1236
msgid "Disconnecting…"
msgstr "Отключение…"

#: src/components/chat/ThreadErrorBanner.tsx:31
msgid "Dismiss error"
msgstr "Закрыть ошибку"

#: src/components/ChatView.tsx:600
msgid "Dismiss version mismatch warning"
msgstr "Закрыть предупреждение о несовпадении версий"

#: src/components/chat/ComposerBannerStack.tsx:186
msgid "Dismiss warning"
msgstr "Закрыть предупреждение"

#: src/components/DocumentsSidebar.tsx:577
msgid "Document actions"
msgstr "Действия с документом"

#: src/components/DocumentsSidebar.tsx:375
msgid "Document deleted"
msgstr "Документ удалён"

#: src/components/chat/DocumentsHeaderButton.tsx:24
#: src/components/settings/UsageSettings.tsx:111
#: src/components/Sidebar.tsx:1386
msgid "Documents"
msgstr "Документы"

#: src/components/DocumentsSidebar.tsx:719
msgid "Documents are unavailable until this thread has an active project."
msgstr "Документы недоступны, пока у чата нет активного проекта."

#: src/components/settings/ConnectionsSettings.tsx:665
msgid "Done"
msgstr "Готово"

#: src/components/DocumentsSidebar.tsx:657
msgid "Download file"
msgstr "Скачать файл"

#: src/components/DocumentsSidebar.tsx:588
msgid "Download original"
msgstr "Скачать оригинал"

#: src/components/DocumentsSidebar.tsx:595
msgid "Download parsed JSON"
msgstr "Скачать распознанный JSON"

#: src/components/CommandPalette.tsx:270
msgid "draft"
msgstr "черновик"

#: src/components/chat/AttachmentsBlock.tsx:166
msgid "Draft attachment could not be saved locally and may be lost on navigation."
msgstr "Вложение черновика не удалось сохранить локально, оно может быть потеряно при переходе."

#: src/components/chat/AttachmentsBlock.tsx:158
msgid "Draft attachment may not persist"
msgstr "Вложение черновика может не сохраниться"

#: src/components/chat/MessagesTimeline.tsx:1473
#: src/components/chat/TurnInspectionButton.tsx:119
#: src/components/settings/DiagnosticsSettings.tsx:1129
#: src/components/settings/DiagnosticsSettings.tsx:1187
msgid "Duration"
msgstr "Длительность"

#: src/components/chat/MessagesTimeline.tsx:1332
msgid "Dynamic tool"
msgstr "Динамический инструмент"

#: src/components/settings/ConnectionsSettings.tsx:871
msgid "e.g. Living room iPad"
msgstr "напр. iPad в гостиной"

#: src/components/settings/KeybindingsSettings.tsx:848
msgid "Edit"
msgstr "Изменить"

#. placeholder {0}: commandLabel(row.command)
#: src/components/settings/KeybindingsSettings.tsx:843
msgid "Edit shortcut for {0}"
msgstr "Изменить сочетание клавиш для {0}"

#. placeholder {0}: commandLabel(row.command)
#: src/components/settings/KeybindingsSettings.tsx:885
msgid "Edit when clause for {0}"
msgstr "Изменить условие when для {0}"

#: src/components/settings/KeybindingsSettings.tsx:1047
msgid "Edit when clause for {commandLabelText}"
msgstr "Изменить условие when для {commandLabelText}"

#: src/components/chat/TurnInspectionButton.tsx:103
msgid "Effort"
msgstr "Усилие"

#: src/components/chat/UserMessageRail.tsx:218
msgid "Empty message"
msgstr "Пустое сообщение"

#: src/components/chat/ChatComposer.tsx:1720
msgid "Enable"
msgstr "Включить"

#: src/components/chat/ChatComposer.tsx:1706
msgid "Enable Deep Work?"
msgstr "Включить Deep Work?"

#: src/components/settings/ConnectionsSettings.tsx:1639
msgid "Enable network access"
msgstr "Включить сетевой доступ"

#: src/components/settings/DiagnosticsSettings.tsx:1129
#: src/components/settings/DiagnosticsSettings.tsx:1187
msgid "Ended"
msgstr "Завершено"

#: src/components/settings/ConnectionsSettings.tsx:300
msgid "Enter a backend host."
msgstr "Введите хост сервера."

#: src/components/settings/ConnectionsSettings.tsx:303
msgid "Enter a pairing code."
msgstr "Введите код подключения."

#: src/environments/primary/auth.ts:335
msgid "Enter a pairing token to continue."
msgstr "Введите токен подключения, чтобы продолжить."

#: src/components/auth/PairingRouteSurface.tsx:118
msgid "Enter your personal token to get started"
msgstr "Введите ваш персональный токен, чтобы начать работу"

#: src/components/chat/ComposerPrimaryActions.tsx:88
msgid "Environment disconnected"
msgstr "Окружение отключено"

#: src/components/ChatView.tsx:455
msgid "Environment reconnected"
msgstr "Окружение переподключено"

#. placeholder {0}: member.environmentLabel
#. placeholder {0}: projectRenameTarget.environmentLabel
#: src/components/Sidebar.tsx:1114
#: src/components/Sidebar.tsx:1124
#: src/components/Sidebar.tsx:1160
#: src/components/Sidebar.tsx:1841
msgid "Environment: {0}"
msgstr "Окружение: {0}"

#: src/components/chat/MessagesTimeline.tsx:941
#: src/components/chat/MessagesTimeline.tsx:1436
#: src/components/DocumentsSidebar.tsx:492
msgid "Error"
msgstr "Ошибка"

#: src/components/settings/ConnectionsSettings.tsx:977
msgid "Every device that opens the link gets its own session."
msgstr "Каждое устройство, открывшее ссылку, получает свою сессию."

#. placeholder {0}: entry.exitCode
#: src/components/chat/MessagesTimeline.tsx:1401
#~ msgid "Exit code {0}"
#~ msgstr ""

#: src/components/chat/MessagesTimeline.tsx:1434
msgid "Exit code {exitCode}"
msgstr "Код выхода {exitCode}"

#: src/components/settings/DiagnosticsSettings.tsx:331
msgid "Expand {name}"
msgstr "Развернуть {name}"

#: src/components/chat/ChatComposer.tsx:1542
msgid "Expand composer"
msgstr "Развернуть поле ввода"

#: src/components/ChatMarkdown.tsx:259
msgid "Expand table cells"
msgstr "Развернуть ячейки таблицы"

#: src/components/chat/ExpandedImageDialog.tsx:66
msgid "Expanded image preview"
msgstr "Увеличенный предпросмотр изображения"

#: src/timestampFormat.ts:104
#: src/timestampFormat.ts:122
msgid "Expired"
msgstr "Истёк"

#. placeholder {0}: formatDuration(0, 0, 0, totalSeconds)
#. placeholder {0}: formatDuration(0, 0, minutes, seconds)
#. placeholder {0}: formatDuration(0, hours, Math.floor(rem / 60), rem % 60)
#: src/timestampFormat.ts:126
#: src/timestampFormat.ts:131
#: src/timestampFormat.ts:137
#: src/timestampFormat.ts:144
msgid "Expires in {0}"
msgstr "Истекает через {0}"

#: src/timestampFormat.ts:125
msgid "Expires in a moment"
msgstr "Истекает через мгновение"

#: src/components/chat/taskStatusLabels.ts:12
msgid "failed"
msgstr "ошибка"

#: src/components/settings/ConnectionsSettings.tsx:1388
msgid "Failed to add backend."
msgstr "Не удалось добавить сервер."

#: src/components/AddSafeProjectDialog.tsx:130
msgid "Failed to add project"
msgstr "Не удалось добавить проект"

#: src/components/Sidebar.tsx:1442
msgid "Failed to archive thread"
msgstr "Не удалось архивировать чат"

#: src/components/Sidebar.tsx:1641
msgid "Failed to block chat"
msgstr "Не удалось заблокировать чат"

#: src/environments/primary/auth.ts:230
msgid "Failed to bootstrap auth session ({status})."
msgstr "Не удалось инициализировать сессию аутентификации ({status})."

#: src/components/settings/ConnectionsSettings.tsx:1409
msgid "Failed to connect backend."
msgstr "Не удалось подключить сервер."

#: src/components/chat/MessageCopyButton.tsx:37
msgid "Failed to copy"
msgstr "Не удалось скопировать"

#: src/components/Sidebar.tsx:795
msgid "Failed to copy link"
msgstr "Не удалось скопировать ссылку"

#: src/components/Sidebar.tsx:775
msgid "Failed to copy path"
msgstr "Не удалось скопировать путь"

#: src/components/Sidebar.tsx:755
msgid "Failed to copy thread ID"
msgstr "Не удалось скопировать ID чата"

#. placeholder {0}: readHttpApiStatus(error) ?? "unknown"
#: src/environments/primary/auth.ts:372
msgid "Failed to create pairing credential ({0})."
msgstr "Не удалось создать учётные данные для подключения ({0})."

#: src/components/settings/ConnectionsSettings.tsx:811
msgid "Failed to create pairing URL."
msgstr "Не удалось создать URL подключения."

#: src/components/settings/ConnectionsSettings.tsx:1432
msgid "Failed to disconnect backend."
msgstr "Не удалось отключить сервер."

#. placeholder {0}: readHttpApiStatus(error) ?? "unknown"
#: src/environments/primary/auth.ts:477
msgid "Failed to load paired clients ({0})."
msgstr "Не удалось загрузить список подключённых клиентов ({0})."

#. placeholder {0}: readHttpApiStatus(error) ?? "unknown"
#: src/environments/primary/auth.ts:424
msgid "Failed to load pairing links ({0})."
msgstr "Не удалось загрузить ссылки для подключения ({0})."

#: src/environments/primary/auth.ts:151
msgid "Failed to load server auth session state ({statusLabel})."
msgstr "Не удалось загрузить состояние сессии аутентификации сервера ({statusLabel})."

#: src/environments/primary/context.ts:65
msgid "Failed to load server environment descriptor ({status})."
msgstr "Не удалось загрузить дескриптор окружения сервера ({status})."

#: src/components/ChatView.tsx:463
msgid "Failed to reconnect."
msgstr "Не удалось переподключиться."

#: src/components/Sidebar.tsx:1145
#: src/components/Sidebar.tsx:1180
msgid "Failed to remove \"\""
msgstr "Не удалось удалить «»"

#: src/components/settings/ConnectionsSettings.tsx:1455
msgid "Failed to remove backend."
msgstr "Не удалось удалить сервер."

#: src/components/Sidebar.tsx:1535
#: src/components/Sidebar.tsx:1554
msgid "Failed to rename project"
msgstr "Не удалось переименовать проект"

#: src/components/Sidebar.tsx:1496
msgid "Failed to rename thread"
msgstr "Не удалось переименовать чат"

#: src/components/ChatView.tsx:1064
#~ msgid "Failed to revert thread state."
#~ msgstr "Не удалось откатить состояние чата."

#: src/components/settings/ConnectionsSettings.tsx:1351
msgid "Failed to revoke client access."
msgstr "Не удалось отозвать доступ клиента."

#. placeholder {0}: readHttpApiStatus(error) ?? "unknown"
#: src/environments/primary/auth.ts:497
msgid "Failed to revoke client session ({0})."
msgstr "Не удалось отозвать сессию клиента ({0})."

#. placeholder {0}: readHttpApiStatus(error) ?? "unknown"
#: src/environments/primary/auth.ts:516
msgid "Failed to revoke other client sessions ({0})."
msgstr "Не удалось отозвать сессии других клиентов ({0})."

#. placeholder {0}: readHttpApiStatus(error) ?? "unknown"
#: src/environments/primary/auth.ts:442
msgid "Failed to revoke pairing link ({0})."
msgstr "Не удалось отозвать ссылку для подключения ({0})."

#: src/components/settings/ConnectionsSettings.tsx:1328
msgid "Failed to revoke pairing link."
msgstr "Не удалось отозвать ссылку для подключения."

#: src/components/settings/DiagnosticsSettings.tsx:908
#: src/components/settings/DiagnosticsSettings.tsx:918
msgid "Failed to send {signal}."
msgstr "Не удалось отправить {signal}."

#: src/components/ChatView.tsx:1249
msgid "Failed to send message."
msgstr "Не удалось отправить сообщение."

#: src/components/settings/SettingsPanels.tsx:477
#: src/components/settings/SettingsPanels.tsx:560
msgid "Failed to unarchive thread"
msgstr "Не удалось разархивировать чат"

#: src/components/Sidebar.tsx:1641
msgid "Failed to unblock chat"
msgstr "Не удалось разблокировать чат"

#: src/components/settings/DiagnosticsSettings.tsx:1078
#: src/components/settings/DiagnosticsSettings.tsx:1290
msgid "Failures"
msgstr "Сбои"

#: src/components/chat/TurnInspectionButton.tsx:106
msgid "Fast"
msgstr "Fast"

#: src/components/settings/CapabilitiesSettings.tsx:291
#: src/components/settings/CapabilitiesSettings.tsx:300
msgid "Fast mode"
msgstr "Быстрый режим"

#: src/components/settings/CapabilitiesSettings.tsx:292
msgid "Faster responses at a higher usage cost."
msgstr "Более быстрые ответы ценой большего расхода лимитов."

#: src/components/chat/MessagesTimeline.tsx:1511
msgid "File"
msgstr "Файл"

#: src/components/DocumentsSidebar.tsx:646
msgid "File actions"
msgstr "Действия с файлом"

#: src/components/chat/MessagesTimeline.tsx:929
#: src/components/chat/MessagesTimeline.tsx:1329
msgid "File change"
msgstr "Изменение файла"

#: src/components/DocumentsSidebar.tsx:414
msgid "File deleted"
msgstr "Файл удалён"

#: src/components/chat/MessagesTimeline.tsx:945
msgid "File-change approval requested"
msgstr "Запрошено одобрение изменения файла"

#: src/components/chat/MessagesTimeline.tsx:944
msgid "File-read approval requested"
msgstr "Запрошено одобрение чтения файла"

#: src/components/ChatView.tsx:1178
msgid "File: {firstComposerFileName}"
msgstr "Файл: {firstComposerFileName}"

#: src/components/chat/MessagesTimeline.tsx:1516
msgid "Files"
msgstr "Файлы"

#: src/components/DocumentsSidebar.tsx:747
msgid "Files the agent creates will appear here."
msgstr "Здесь появятся файлы, которые создаёт агент."

#: src/components/chat/taskStatusLabels.ts:11
msgid "finished"
msgstr "завершено"

#: src/components/settings/KeybindingsSettings.tsx:726
msgid "Fix the expression above to continue editing visually."
msgstr "Исправьте выражение выше, чтобы продолжить визуальное редактирование."

#: src/components/CommandPalette.tsx:305
msgid "folder"
msgstr "папка"

#: src/components/chat/BasaDocumentDialog.tsx:213
msgid "Full text"
msgstr "Полный текст"

#: src/components/settings/settingsNavItems.ts:31
#: src/components/settings/SettingsPanels.tsx:193
msgid "General"
msgstr "Общие"

#: src/components/settings/ConnectionsSettings.tsx:858
msgid "Generate a link that pairs devices with this backend as an authorized client."
msgstr "Создайте ссылку, по которой устройства подключаются к этому бэкенду как авторизованный клиент."

#: src/components/Sidebar.tsx:2064
msgid "Go to threads"
msgstr "Перейти к чатам"

#: src/components/settings/ConnectionsSettings.tsx:167
#: src/components/settings/ConnectionsSettings.tsx:1211
msgid "Granted scopes"
msgstr "Предоставленные права"

#: src/components/settings/KeybindingsSettings.tsx:540
#: src/components/settings/KeybindingsSettings.tsx:663
#: src/components/settings/KeybindingsSettings.tsx:719
msgid "Group"
msgstr "Группа"

#: src/components/Sidebar.tsx:189
#~ msgid "Group by repository"
#~ msgstr "Группировать по репозиторию"

#: src/components/Sidebar.tsx:190
#~ msgid "Group by repository path"
#~ msgstr "Группировать по пути репозитория"

#: src/components/Sidebar.tsx:2034
#~ msgid "Group projects"
#~ msgstr "Группировать проекты"

#: src/components/chat/MessagesTimeline.tsx:1331
msgid "Helper agent"
msgstr "Помощник"

#: src/components/chat/ChatComposer.tsx:130
#: src/components/chat/CompactComposerControlsMenu.tsx:60
msgid "Hide {planSidebarLabel} sidebar"
msgstr "Скрыть боковую панель {planSidebarLabel}"

#: src/routes/__root.tsx:215
msgid "Hide error details"
msgstr "Скрыть подробности ошибки"

#: src/components/chat/MessagesTimeline.tsx:1110
msgid "Hide raw details"
msgstr "Скрыть сырые данные"

#: src/components/WebSocketConnectionSurface.tsx:523
msgid "Hide requests"
msgstr "Скрыть запросы"

#: src/components/settings/ConnectionsSettings.tsx:1560
msgid "Host"
msgstr "Хост"

#. placeholder {0}: request.host
#: src/components/auth/PairingRouteSurface.tsx:248
msgid "Host: <0>{0}</0>"
msgstr "Хост: <0>{0}</0>"

#: src/components/settings/ConnectionsSettings.tsx:944
msgid "How many devices can pair with this link."
msgstr "Сколько устройств могут подключиться по этой ссылке."

#: src/components/settings/CapabilitiesSettings.tsx:261
msgid "How much the model reasons before it answers."
msgstr "Насколько глубоко модель рассуждает перед ответом."

#: src/components/chat/MessagesTimeline.tsx:934
#: src/components/chat/MessagesTimeline.tsx:1328
msgid "Image view"
msgstr "Просмотр изображения"

#: src/components/ChatView.tsx:1176
msgid "Image: {firstComposerImageName}"
msgstr "Изображение: {firstComposerImageName}"

#: src/components/settings/DiagnosticsSettings.tsx:1024
msgid "In-memory process samples retained by the server. This resets when the server restarts."
msgstr "Замеры процессов в памяти, сохраняемые сервером. Сбрасываются при перезапуске сервера."

#: src/components/Sidebar.tsx:2006
msgid "Increase visible thread count"
msgstr "Увеличить число видимых чатов"

#: src/components/chat/TurnInspectionButton.tsx:110
msgid "Input"
msgstr "Вход"

#: src/components/chat/TurnInspectionButton.tsx:111
msgid "Input (cached)"
msgstr "Вход (кэш)"

#: src/components/settings/ConnectionsSettings.tsx:132
#~ msgid "Inspect agent actions"
#~ msgstr "Сырые данные действий агента"

#: src/components/settings/ConnectionsSettings.tsx:122
msgid "Inspect pairing links and authorized clients."
msgstr "Просмотрите ссылки для подключения и авторизованных клиентов."

#: src/components/ChatView.tsx:1037
#~ msgid "Interrupt the current turn before reverting checkpoints."
#~ msgstr "Прервите текущий ход перед откатом контрольных точек."

#: src/components/settings/DiagnosticsSettings.tsx:1027
msgid "Interval"
msgstr "Интервал"

#: src/environments/primary/auth.ts:193
msgid "Invalid bootstrap credential."
msgstr "Недействительные учётные данные для подключения."

#: src/routes/__root.tsx:375
msgid "Invalid keybindings configuration"
msgstr "Неверная конфигурация сочетаний клавиш"

#: src/environments/primary/auth.ts:227
msgid "Invalid pairing token. Check the token and try again."
msgstr "Недействительный токен подключения. Проверьте токен и попробуйте ещё раз."

#: src/components/settings/ConnectionsSettings.tsx:127
msgid "Issue and revoke credentials for other clients."
msgstr "Выдавайте и отзывайте учётные данные для других клиентов."

#: src/components/chat/ContextWindowMeter.tsx:128
#~ msgid "It automatically compacts its context when needed."
#~ msgstr "Он автоматически сжимает контекст при необходимости."

#: src/components/chat/MessagesTimeline.tsx:942
msgid "Item"
msgstr "Элемент"

#: src/components/chat/UserMessageRail.tsx:183
msgid "Jump to message"
msgstr "Перейти к сообщению"

#: src/components/settings/ConnectionsSettings.tsx:490
#: src/timestampFormat.ts:61
#: src/timestampFormat.ts:63
#: src/timestampFormat.ts:83
#: src/timestampFormat.ts:86
msgid "just now"
msgstr "только что"

#: src/components/Sidebar.tsx:191
#~ msgid "Keep separate"
#~ msgstr "Держать раздельно"

#: src/components/settings/KeybindingsSettings.tsx:1259
msgid "Keybinding"
msgstr "Сочетание клавиш"

#. placeholder {0}: commandLabel(row.command)
#: src/components/settings/KeybindingsSettings.tsx:854
msgid "Keybinding for {0}"
msgstr "Сочетание клавиш для {0}"

#: src/components/settings/KeybindingsSettings.tsx:1019
msgid "Keybinding for {commandLabelText}"
msgstr "Сочетание клавиш для {commandLabelText}"

#: src/components/CommandPalette.tsx:318
msgid "keybindings"
msgstr "сочетания клавиш"

#: src/components/settings/KeybindingsSettings.tsx:1206
#: src/components/settings/settingsNavItems.ts:32
msgid "Keybindings"
msgstr "Сочетания клавиш"

#: src/routes/__root.tsx:367
msgid "Keybindings configuration reloaded successfully."
msgstr "Конфигурация сочетаний клавиш успешно перезагружена."

#: src/routes/__root.tsx:366
msgid "Keybindings updated"
msgstr "Сочетания клавиш обновлены"

#: src/components/settings/DiagnosticsSettings.tsx:486
msgid "Kill"
msgstr "Завершить"

#: src/components/settings/SettingsPanels.tsx:234
msgid "language"
msgstr "язык"

#: src/components/settings/SettingsPanels.tsx:128
#: src/components/settings/SettingsPanels.tsx:230
msgid "Language"
msgstr "Язык"

#: src/components/settings/SettingsPanels.tsx:231
msgid "Language of the app interface."
msgstr "Язык интерфейса приложения."

#: src/components/settings/SettingsPanels.tsx:246
msgid "Language preference"
msgstr "Язык интерфейса"

#. placeholder {0}: formatAccessTimestamp(record.lastConnectedAt)
#: src/components/settings/ConnectionsSettings.tsx:1188
msgid "Last connected {0}"
msgstr "Последнее подключение: {0}"

#. placeholder {0}: formatAccessTimestamp(lastConnectedAt)
#. placeholder {0}: formatAccessTimestamp(record.lastConnectedAt)
#: src/components/settings/ConnectionsSettings.tsx:255
#: src/components/settings/ConnectionsSettings.tsx:717
msgid "Last connected at {0}"
msgstr "Последнее подключение в {0}"

#: src/components/settings/DiagnosticsSettings.tsx:1157
msgid "Last Seen"
msgstr "Последняя активность"

#: src/components/chat/MessagesTimeline.tsx:1441
#~ msgid "Last tool: {lastToolName}"
#~ msgstr "Последний инструмент: {lastToolName}"

#: src/components/Sidebar.tsx:173
#: src/components/Sidebar.tsx:178
msgid "Last user message"
msgstr "Последнее сообщение пользователя"

#: src/components/settings/SettingsPanels.tsx:104
msgid "Latest"
msgstr "Последняя"

#: src/components/settings/DiagnosticsSettings.tsx:1127
msgid "Latest Failures"
msgstr "Последние сбои"

#: src/timestampFormat.ts:107
#: src/timestampFormat.ts:109
#: src/timestampFormat.ts:111
#: src/timestampFormat.ts:113
msgid "left"
msgstr "осталось"

#: src/components/settings/DiagnosticsSettings.tsx:1235
msgid "Level"
msgstr "Уровень"

#: src/components/settings/ConnectionsSettings.tsx:987
#: src/components/settings/ConnectionsSettings.tsx:1003
msgid "Lifetime"
msgstr "Срок жизни"

#: src/components/settings/SettingsPanels.tsx:51
msgid "Light"
msgstr "Светлая"

#: src/components/settings/ConnectionsSettings.tsx:883
msgid "Limit what the paired client can do."
msgstr "Ограничьте, что может делать подключённый клиент."

#: src/components/Sidebar.tsx:787
msgid "Link copied"
msgstr "Ссылка скопирована"

#. placeholder {0}: formatAccessTimestamp(pairingLink.createdAt)
#: src/components/settings/ConnectionsSettings.tsx:526
msgid "Link created at {0}"
msgstr "Ссылка создана в {0}"

#: src/components/settings/DiagnosticsSettings.tsx:938
msgid "Live Processes"
msgstr "Активные процессы"

#: src/components/chat/MessagesTimeline.tsx:1394
msgid "Load full payload"
msgstr "Загрузить полностью"

#: src/components/settings/SettingsPanels.tsx:506
msgid "Loading archived threads"
msgstr "Загрузка архивированных чатов"

#: src/components/chat/MessagesTimeline.tsx:342
msgid "Loading chat"
msgstr "Загружаю чат"

#: src/components/chat/MessagesTimeline.tsx:266
msgid "Loading earlier messages…"
msgstr "Загрузка более ранних сообщений…"

#: src/components/settings/DiagnosticsSettings.tsx:1179
msgid "Loading failure groups..."
msgstr "Загрузка групп сбоев..."

#: src/components/settings/DiagnosticsSettings.tsx:1149
msgid "Loading failures..."
msgstr "Загрузка сбоев..."

#: src/components/settings/DiagnosticsSettings.tsx:992
msgid "Loading live processes..."
msgstr "Загрузка активных процессов..."

#: src/components/settings/DiagnosticsSettings.tsx:1282
msgid "Loading recent logs..."
msgstr "Загрузка недавних логов..."

#: src/components/settings/DiagnosticsSettings.tsx:1209
msgid "Loading slow spans..."
msgstr "Загрузка медленных спанов..."

#: src/components/settings/DiagnosticsSettings.tsx:1315
msgid "Loading span names..."
msgstr "Загрузка имён спанов..."

#: src/components/chat/BasaDocumentDialog.tsx:232
#: src/components/chat/MessagesTimeline.tsx:1394
msgid "Loading…"
msgstr "Загрузка…"

#: src/components/settings/ConnectionsSettings.tsx:126
msgid "Manage access"
msgstr "Управление доступом"

#: src/components/Sidebar.tsx:175
msgid "Manual"
msgstr "Вручную"

#: src/components/Sidebar.tsx:1575
msgid "Mark unread"
msgstr "Отметить непрочитанным"

#: src/components/DocumentsSidebar.tsx:783
msgid "Materials"
msgstr "Материалы"

#: src/components/settings/DiagnosticsSettings.tsx:1290
msgid "Max"
msgstr "Макс."

#: src/components/settings/DiagnosticsSettings.tsx:730
msgid "Max Mem"
msgstr "Макс. память"

#: src/components/chat/MessagesTimeline.tsx:1327
msgid "MCP tool"
msgstr "MCP-инструмент"

#: src/components/chat/MessagesTimeline.tsx:935
msgid "MCP tool call"
msgstr "Вызов MCP-инструмента"

#: src/components/settings/DiagnosticsSettings.tsx:474
#: src/components/settings/DiagnosticsSettings.tsx:961
msgid "Memory"
msgstr "Память"

#: src/components/settings/DiagnosticsSettings.tsx:1241
msgid "Message"
msgstr "Сообщение"

#: src/hooks/useVoiceInput.ts:151
msgid "Microphone access granted"
msgstr "Доступ к микрофону получен"

#: src/hooks/useVoiceInput.ts:125
msgid "Microphone access is blocked"
msgstr "Доступ к микрофону запрещён"

#: src/components/settings/CapabilitiesSettings.tsx:50
msgid "Microphone button in the composer; recordings are transcribed through docparser."
msgstr "Кнопка микрофона в композере; записи распознаются через docparser."

#: src/hooks/useVoiceInput.ts:130
msgid "Microphone is unavailable"
msgstr "Микрофон недоступен"

#: src/components/settings/CapabilitiesSettings.tsx:231
msgid "model"
msgstr "модель"

#: src/components/chat/TurnInspectionButton.tsx:100
#: src/components/settings/CapabilitiesSettings.tsx:226
#: src/components/settings/CapabilitiesSettings.tsx:245
msgid "Model"
msgstr "Модель"

#: src/components/DocumentsSidebar.tsx:564
#: src/components/DocumentsSidebar.tsx:633
msgid "Modified"
msgstr "Изменён"

#: src/components/chat/CompactComposerControlsMenu.tsx:77
msgid "More composer controls"
msgstr "Дополнительные элементы управления"

#: src/components/settings/ConnectionsSettings.tsx:601
msgid "More copy options"
msgstr "Другие варианты копирования"

#: src/components/settings/DiagnosticsSettings.tsx:1154
msgid "Most Common Failures"
msgstr "Наиболее частые сбои"

#: src/components/DocumentsSidebar.tsx:504
#: src/components/DocumentsSidebar.tsx:615
#: src/components/settings/DiagnosticsSettings.tsx:468
msgid "Name"
msgstr "Имя"

#: src/components/CommandPalette.tsx:434
msgid "Navigate"
msgstr "Навигация"

#. placeholder {0}: condition.identifier
#: src/components/settings/KeybindingsSettings.tsx:365
msgid "Negate {0}"
msgstr "Инвертировать {0}"

#: src/components/settings/KeybindingsSettings.tsx:406
msgid "Negate group"
msgstr "Инвертировать группу"

#: src/components/settings/ConnectionsSettings.tsx:1625
msgid "Network access"
msgstr "Сетевой доступ"

#: src/components/settings/ConnectionsSettings.tsx:1645
msgid "Network exposure changes restart the backend and must be controlled where the server process is launched."
msgstr "Изменение сетевого доступа перезапускает сервер и управляется там, где запущен серверный процесс."

#: src/components/settings/ConnectionsSettings.tsx:477
#: src/components/settings/ConnectionsSettings.tsx:481
msgid "Never expires"
msgstr "Бессрочная"

#: src/components/settings/ConnectionsSettings.tsx:504
msgid "Never used"
msgstr "Не использовалась"

#: src/components/settings/KeybindingsSettings.tsx:968
msgid "new keybinding"
msgstr "новое сочетание клавиш"

#: src/components/AddSafeProjectDialog.tsx:148
msgid "New project"
msgstr "Новый проект"

#: src/components/Sidebar.tsx:2237
msgid "New project..."
msgstr "Новый проект..."

#: src/components/CommandPalette.tsx:270
#: src/components/CommandPalette.tsx:292
msgid "new thread"
msgstr "новый чат"

#: src/components/ChatView.logic.ts:25
#: src/components/ChatView.tsx:1180
#: src/components/Sidebar.tsx:1384
msgid "New thread"
msgstr "Новый чат"

#: src/components/CommandPalette.tsx:272
msgid "New thread in <0>{activeProjectTitle}</0>"
msgstr "Новый чат в <0>{activeProjectTitle}</0>"

#: src/components/CommandPalette.tsx:293
msgid "New thread in..."
msgstr "Новый чат в..."

#: src/components/Sidebar.tsx:2251
msgid "New thread..."
msgstr "Новый чат..."

#: src/components/chat/ExpandedImageDialog.tsx:114
msgid "Next image"
msgstr "Следующее изображение"

#: src/components/settings/SettingsPanels.tsx:107
msgid "Nightly"
msgstr "Ночная сборка"

#: src/components/PlanSidebar.tsx:133
msgid "No active plan yet."
msgstr "Пока нет активного плана."

#: src/components/NoActiveThreadState.tsx:13
msgid "No active thread"
msgstr "Нет активного чата"

#: src/routes/__root.tsx:251
msgid "No additional error details are available."
msgstr "Дополнительные сведения об ошибке недоступны."

#: src/components/settings/SettingsPanels.tsx:509
msgid "No archived threads"
msgstr "Нет архивированных чатов"

#: src/components/DocumentsSidebar.tsx:744
msgid "No created files in this project yet."
msgstr "В проекте пока нет созданных файлов."

#. placeholder {0}: searchQuery.trim()
#: src/components/DocumentsSidebar.tsx:730
msgid "No documents match “{0}”."
msgstr "Ничего не найдено по «{0}»."

#: src/components/settings/ConnectionsSettings.tsx:1008
#: src/components/settings/ConnectionsSettings.tsx:1014
msgid "No expiry"
msgstr "Без срока"

#: src/components/settings/DiagnosticsSettings.tsx:1149
msgid "No failed spans found."
msgstr "Спаны со сбоями не найдены."

#: src/components/settings/KeybindingsSettings.tsx:1293
msgid "No keybindings match your search."
msgstr "Нет сочетаний клавиш по вашему запросу."

#: src/components/settings/DiagnosticsSettings.tsx:494
#: src/components/settings/DiagnosticsSettings.tsx:993
msgid "No live descendant processes found."
msgstr "Активные дочерние процессы не найдены."

#: src/components/CommandPaletteResults.tsx:36
msgid "No matching actions."
msgstr "Нет подходящих действий."

#: src/components/chat/ChatComposer.tsx:627
#: src/components/chat/ComposerCommandMenu.tsx:167
msgid "No matching command."
msgstr "Нет подходящей команды."

#: src/components/CommandPaletteResults.tsx:37
msgid "No matching commands, projects, or threads."
msgstr "Нет подходящих команд, проектов или чатов."

#: src/components/chat/ChatComposer.tsx:626
#: src/components/chat/ComposerCommandMenu.tsx:166
msgid "No matching files or folders."
msgstr "Нет подходящих файлов или папок."

#: src/components/chat/DraftProjectChip.tsx:157
msgid "No matching projects."
msgstr "Проекты не найдены."

#: src/components/DocumentsSidebar.tsx:735
msgid "No materials in this project yet."
msgstr "В проекте пока нет материалов."

#: src/components/chat/MessagesTimeline.tsx:1398
msgid "No output"
msgstr "Вывода нет"

#: src/components/settings/ConnectionsSettings.tsx:1133
msgid "No pairing links or client sessions."
msgstr "Нет ссылок для подключения и клиентских сессий."

#: src/components/settings/DiagnosticsSettings.tsx:1057
msgid "No process resource samples found for this window."
msgstr "Замеры ресурсов процессов за этот период не найдены."

#: src/components/settings/UsageSettings.tsx:100
msgid "No projects yet."
msgstr "Проектов пока нет."

#: src/components/chat/MessagesTimeline.tsx:1443
#~ msgid "No raw details"
#~ msgstr "Нет сырых данных"

#: src/components/settings/DiagnosticsSettings.tsx:1179
msgid "No repeated failures found."
msgstr "Повторяющиеся сбои не найдены."

#: src/components/chat/MessagesTimeline.tsx:1098
#: src/components/chat/MessagesTimeline.tsx:1456
msgid "no rule"
msgstr "без правила"

#: src/components/settings/ConnectionsSettings.tsx:1272
msgid "No saved remote environments"
msgstr "Нет сохранённых окружений"

#: src/components/chat/ChatComposer.tsx:623
#: src/components/chat/ComposerCommandMenu.tsx:157
msgid "No skills found. Try / to browse provider commands."
msgstr "Навыки не найдены. Нажмите /, чтобы просмотреть команды провайдера."

#: src/components/settings/DiagnosticsSettings.tsx:1209
#: src/components/settings/DiagnosticsSettings.tsx:1315
msgid "No spans found."
msgstr "Спаны не найдены."

#: src/components/Sidebar.tsx:609
msgid "No threads yet"
msgstr "Пока нет чатов"

#: src/components/settings/DiagnosticsSettings.tsx:59
msgid "No trace records"
msgstr "Нет записей трейсов"

#: src/components/SubAgentThreadView.tsx:169
#: src/components/SubAgentThreadView.tsx:175
msgid "No transcript yet"
msgstr "Транскрипта пока нет"

#: src/components/settings/DiagnosticsSettings.tsx:1282
msgid "No warnings or errors found."
msgstr "Предупреждения и ошибки не найдены."

#: src/components/settings/KeybindingsSettings.tsx:370
#: src/components/settings/KeybindingsSettings.tsx:411
msgid "Not"
msgstr "Не"

#: src/components/settings/ConnectionsSettings.tsx:256
#: src/components/settings/ConnectionsSettings.tsx:718
msgid "Not connected yet."
msgstr "Ещё не подключено."

#: src/components/chat/MessagesTimeline.tsx:1385
msgid "Not loaded yet"
msgstr "Ещё не загружен"

#: src/hooks/useVoiceInput.ts:81
msgid "Nothing was recorded"
msgstr "Ничего не записалось"

#: src/components/settings/UsageSettings.tsx:89
msgid "OCR usage"
msgstr "Расход OCR"

#: src/components/chat/CompactComposerControlsMenu.tsx:46
msgid "Off"
msgstr "Выкл."

#: src/components/chat/CompactComposerControlsMenu.tsx:43
msgid "On"
msgstr "Вкл."

#: src/components/settings/ConnectionsSettings.tsx:497
msgid "One-time"
msgstr "Одноразовая"

#: src/routes/_chat.index.tsx:72
msgid "Open a pairing link or add a reachable backend manually. Your saved environments stay in this browser."
msgstr "Откройте ссылку для подключения или добавьте доступный сервер вручную. Ваши сохранённые окружения останутся в этом браузере."

#: src/components/auth/PairingRouteSurface.tsx:275
msgid "Open app"
msgstr "Открыть приложение"

#: src/components/settings/ConnectionsSettings.tsx:439
msgid "Open it in the client you want to pair to this environment."
msgstr "Откройте её в клиенте, который хотите подключить к этому окружению."

#: src/components/CommandPalette.tsx:319
msgid "Open settings"
msgstr "Открыть настройки"

#: src/components/settings/SettingsPanels.tsx:306
msgid "Open the right-side plan and task panel automatically when steps appear."
msgstr "Автоматически открывать правую панель плана и задач при появлении шагов."

#: src/components/settings/SettingsPanels.tsx:325
msgid "Open the task panel automatically"
msgstr "Автоматически открывать панель задач"

#: src/components/settings/ConnectionsSettings.tsx:111
msgid "Operate tasks"
msgstr "Управление задачами"

#: src/components/chat/MessagesTimeline.tsx:1375
msgid "Output"
msgstr "Вывод"

#: src/components/chat/TurnInspectionButton.tsx:113
msgctxt "token usage"
msgid "Output"
msgstr "Выход"

#: src/components/DocumentsSidebar.tsx:546
#: src/components/settings/UsageSettings.tsx:114
msgid "Pages"
msgstr "Стр."

#: src/components/settings/UsageSettings.tsx:117
msgid "Paid pages"
msgstr "Платные стр."

#: src/components/settings/ConnectionsSettings.tsx:1738
msgid "Pair another environment to this client."
msgstr "Подключите к этому клиенту ещё одно окружение."

#: src/components/auth/PairingRouteSurface.tsx:115
msgid "Pair with this environment"
msgstr "Получить доступ"

#: src/components/auth/PairingRouteSurface.tsx:241
msgid "Pairing backend"
msgstr "Подключение к серверу"

#: src/components/settings/ConnectionsSettings.tsx:626
#: src/components/settings/ConnectionsSettings.tsx:1572
msgid "Pairing code"
msgstr "Код подключения"

#: src/components/settings/ConnectionsSettings.tsx:436
msgid "Pairing code copied"
msgstr "Код подключения скопирован"

#: src/components/auth/PairingRouteSurface.tsx:239
msgid "Pairing failed"
msgstr "Не удалось подключиться"

#: src/components/settings/ConnectionsSettings.tsx:506
#: src/components/settings/ConnectionsSettings.tsx:626
msgid "Pairing link"
msgstr "Ссылка для подключения"

#: src/components/settings/ConnectionsSettings.tsx:555
#: src/components/settings/ConnectionsSettings.tsx:658
msgid "Pairing link — scan to open on another device"
msgstr "Ссылка для подключения — отсканируйте, чтобы открыть на другом устройстве"

#: src/components/settings/ConnectionsSettings.tsx:572
msgid "Pairing link scopes"
msgstr "Права ссылки для подключения"

#: src/components/settings/ConnectionsSettings.tsx:1691
msgid "Pairing links and client-session management require the access:write scope for this backend."
msgstr "Управление ссылками для подключения и клиентскими сессиями требует права access:write для этого сервера."

#: src/components/auth/PairingRouteSurface.tsx:312
#~ msgid "Pairing links can open this page directly, or you can paste the token here."
#~ msgstr "Ссылки для подключения открывают эту страницу напрямую, либо вставьте токен сюда."

#: src/components/auth/PairingRouteSurface.tsx:125
msgid "Pairing token"
msgstr "Токен подключения"

#: src/components/settings/ConnectionsSettings.tsx:436
msgid "Pairing URL copied"
msgstr "URL подключения скопирован"

#: src/components/auth/PairingRouteSurface.tsx:31
msgid "Pairing with this environment"
msgstr "Подключение к этому окружению"

#: src/components/auth/PairingRouteSurface.tsx:138
#: src/components/auth/PairingRouteSurface.tsx:266
msgid "Pairing..."
msgstr "Подключение..."

#: src/components/settings/DiagnosticsSettings.tsx:1093
msgid "Parse Errors"
msgstr "Ошибки разбора"

#: src/components/settings/ConnectionsSettings.tsx:1585
msgid "Paste a full pairing URL here to fill both fields automatically."
msgstr "Вставьте сюда полную ссылку для подключения, чтобы оба поля заполнились автоматически."

#: src/components/settings/ConnectionsSettings.tsx:440
msgid "Paste it into another client to finish pairing."
msgstr "Вставьте его в другой клиент, чтобы завершить подключение."

#: src/components/Sidebar.tsx:767
msgid "Path copied"
msgstr "Путь скопирован"

#. placeholder {0}: member.cwd
#: src/components/Sidebar.tsx:1112
#: src/components/Sidebar.tsx:1122
#: src/components/Sidebar.tsx:1159
msgid "Path: {0}"
msgstr "Путь: {0}"

#: src/components/settings/DiagnosticsSettings.tsx:727
msgid "Peak"
msgstr "Пик"

#: src/components/DocumentsSidebar.tsx:491
msgid "Pending"
msgstr "Ожидает"

#: src/components/settings/ConnectionsSettings.tsx:880
msgid "Permissions"
msgstr "Разрешения"

#: src/components/CommandPalette.tsx:292
msgid "pick"
msgstr "выбрать"

#: src/components/NoActiveThreadState.tsx:22
msgid "Pick a thread to continue"
msgstr "Выберите чат, чтобы продолжить"

#: src/components/chat/DraftProjectChip.tsx:104
msgid "Pick the project this message is for."
msgstr "Выберите проект, к которому относится это сообщение."

#: src/components/settings/DiagnosticsSettings.tsx:480
#: src/components/settings/DiagnosticsSettings.tsx:736
msgid "PID"
msgstr "PID"

#: src/components/chat/MessagesTimeline.tsx:940
msgid "Plan"
msgstr "План"

#: src/components/chat/MessagesTimeline.tsx:948
msgid "Plan updated"
msgstr "План обновлён"

#: src/components/PlanSidebar.tsx:136
msgid "Plans will appear here when generated."
msgstr "Планы появятся здесь после генерации."

#: src/components/CommandPalette.tsx:318
msgid "preferences"
msgstr "настройки"

#: src/components/settings/KeybindingsSettings.tsx:856
#: src/components/settings/KeybindingsSettings.tsx:1021
msgid "Press shortcut"
msgstr "Нажмите сочетание клавиш"

#: src/hooks/useVoiceInput.ts:152
msgid "Press the microphone again to start recording."
msgstr "Нажмите микрофон ещё раз, чтобы начать запись."

#. placeholder {0}: attachment.name
#: src/components/chat/AttachmentsBlock.tsx:138
msgid "Preview {0}"
msgstr "Предпросмотр {0}"

#: src/components/chat/ExpandedImageDialog.tsx:80
msgid "Previous image"
msgstr "Предыдущее изображение"

#: src/components/settings/DiagnosticsSettings.tsx:305
#: src/components/settings/DiagnosticsSettings.tsx:715
msgid "Process"
msgstr "Процесс"

#: src/components/settings/DiagnosticsSettings.tsx:899
msgid "Process already exited"
msgstr "Процесс уже завершён"

#: src/components/settings/DiagnosticsSettings.tsx:1031
msgid "Processes"
msgstr "Процессы"

#: src/components/CommandPalette.tsx:292
msgid "project"
msgstr "проект"

#: src/components/settings/UsageSettings.tsx:108
msgid "Project"
msgstr "Проект"

#: src/components/Sidebar.tsx:1536
msgid "Project API unavailable."
msgstr "API проекта недоступен."

#: src/components/Sidebar.tsx:1089
msgid "Project is not empty"
msgstr "Проект не пуст"

#: src/components/AddSafeProjectDialog.tsx:156
#: src/components/AddSafeProjectDialog.tsx:157
msgid "Project name"
msgstr "Имя проекта"

#: src/components/chat/DraftProjectChip.tsx:98
msgid "Project not selected"
msgstr "Проект не выбран"

#: src/components/Sidebar.tsx:1825
#: src/components/Sidebar.tsx:1828
msgid "Project title"
msgstr "Название проекта"

#: src/components/Sidebar.tsx:1520
msgid "Project title cannot be empty"
msgstr "Название проекта не может быть пустым"

#: src/components/chat/DraftProjectChip.tsx:79
#: src/components/CommandPalette.logic.ts:208
#: src/components/CommandPalette.tsx:296
#: src/components/Sidebar.tsx:2260
msgid "Projects"
msgstr "Проекты"

#: src/components/chat/MessagesTimeline.tsx:1506
msgid "Query"
msgstr "Запрос"

#: src/components/chat/MessagesTimeline.tsx:524
msgid "Question"
msgstr "Вопрос"

#: src/components/chat/MessagesTimeline.tsx:927
msgid "Ran command"
msgstr "Запуск команды"

#: src/components/settings/InspectSettings.tsx:23
#: src/components/settings/InspectSettings.tsx:29
#~ msgid "Raw step data"
#~ msgstr "Сырые данные шагов"

#: src/components/settings/InspectSettings.tsx:23
#: src/components/settings/InspectSettings.tsx:29
#~ msgid "Raw tool calls"
#~ msgstr "Сырые вызовы инструментов"

#: src/components/chat/MessagesTimeline.tsx:931
msgid "Read file"
msgstr "Чтение файла"

#: src/components/settings/ConnectionsSettings.tsx:893
msgid "Read only"
msgstr "Только чтение"

#: src/components/settings/ConnectionsSettings.tsx:107
msgid "Read threads, status, diffs, and configuration."
msgstr "Чтение чатов, статуса, диффов и конфигурации."

#: src/components/DocumentsSidebar.tsx:490
msgid "Ready"
msgstr "Готов"

#: src/components/chat/MessagesTimeline.tsx:939
msgid "Reasoning"
msgstr "Рассуждение"

#: src/components/settings/CapabilitiesSettings.tsx:260
#: src/components/settings/CapabilitiesSettings.tsx:272
msgid "Reasoning effort"
msgstr "Уровень рассуждений"

#: src/components/chat/MessagesTimeline.tsx:951
msgid "Reasoning update"
msgstr "Обновление рассуждений"

#: src/components/CommandPalette.logic.ts:262
msgid "Recent Threads"
msgstr "Недавние чаты"

#: src/components/ChatView.tsx:574
msgid "Reconnect"
msgstr "Переподключить"

#: src/components/ChatView.tsx:1030
#~ msgid "Reconnect {activeEnvironmentUnavailableLabel} before reverting checkpoints."
#~ msgstr "Переподключите {activeEnvironmentUnavailableLabel} перед откатом контрольных точек."

#: src/components/WebSocketConnectionSurface.tsx:242
msgid "Reconnect failed"
msgstr "Не удалось переподключиться"

#: src/components/ChatView.tsx:554
msgid "Reconnect this environment before sending messages or running actions."
msgstr "Переподключите это окружение перед отправкой сообщений или запуском действий."

#. placeholder {0}: getConnectionDisplayName(status)
#: src/components/WebSocketConnectionSurface.tsx:66
msgid "Reconnected to {0}"
msgstr "Переподключено к {0}"

#. placeholder {0}: formatRetryCountdown(status.nextRetryAt, nowMs)
#. placeholder {1}: formatReconnectAttemptLabel(status)
#: src/components/WebSocketConnectionSurface.tsx:435
msgid "Reconnecting in {0}... {1}"
msgstr "Переподключение через {0}... {1}"

#: src/components/ChatView.tsx:572
msgid "Reconnecting..."
msgstr "Переподключение..."

#. placeholder {0}: formatReconnectAttemptLabel(status)
#: src/components/WebSocketConnectionSurface.tsx:434
msgid "Reconnecting... {0}"
msgstr "Переподключение... {0}"

#: src/components/chat/ChatComposer.tsx:1116
msgid "Recording stopped"
msgstr "Запись остановлена"

#: src/components/chat/ChatComposer.tsx:1117
msgid "Recordings are limited to 30 minutes."
msgstr "Ограничение записи — 30 минут."

#: src/components/StaleClientToastCoordinator.tsx:45
msgid "Refresh"
msgstr "Обновить"

#: src/components/DocumentsSidebar.tsx:800
msgid "Refresh documents"
msgstr "Обновить список документов"

#: src/components/settings/DiagnosticsSettings.tsx:944
msgid "Refresh process diagnostics"
msgstr "Обновить диагностику процессов"

#: src/components/settings/DiagnosticsSettings.tsx:1009
msgid "Refresh resource history"
msgstr "Обновить историю ресурсов"

#: src/components/StaleClientToastCoordinator.tsx:42
msgid "Refresh the page to keep {APP_BASE_NAME} working correctly."
msgstr "Обновите страницу, чтобы сервис работал корректно."

#: src/components/settings/DiagnosticsSettings.tsx:1069
msgid "Refresh trace diagnostics"
msgstr "Обновить диагностику трейсов"

#: src/routes/__root.tsx:205
msgid "Reload app"
msgstr "Перезагрузить приложение"

#: src/components/CommandPalette.tsx:308
#~ msgid "remote"
#~ msgstr "внешний"

#: src/components/Sidebar.tsx:305
#: src/components/Sidebar.tsx:471
#: src/components/ThreadStatusIndicators.tsx:139
#: src/components/ThreadStatusIndicators.tsx:151
msgid "Remote"
msgstr "Внешний"

#. placeholder {0}: project.remoteEnvironmentLabels.join(", ")
#: src/components/Sidebar.tsx:1756
msgid "Remote environment: {0}"
msgstr "Внешнее окружение: {0}"

#: src/components/settings/ConnectionsSettings.tsx:1697
msgid "Remote environments"
msgstr "Внешние окружения"

#: src/components/Sidebar.tsx:1746
msgid "Remote project"
msgstr "Внешний проект"

#: src/components/settings/ConnectionsSettings.tsx:1255
#: src/components/settings/KeybindingsSettings.tsx:926
#: src/components/Sidebar.tsx:1391
msgid "Remove"
msgstr "Удалить"

#. placeholder {0}: attachment.name
#: src/components/chat/AttachmentsBlock.tsx:178
msgid "Remove {0}"
msgstr "Удалить {0}"

#: src/components/settings/KeybindingsSettings.tsx:384
msgid "Remove condition"
msgstr "Удалить условие"

#: src/components/settings/KeybindingsSettings.tsx:548
msgid "Remove group"
msgstr "Удалить группу"

#: src/components/settings/KeybindingsSettings.tsx:419
msgid "Remove negated group"
msgstr "Удалить инвертированную группу"

#. placeholder {0}: member.name
#: src/components/Sidebar.tsx:1121
#: src/components/Sidebar.tsx:1158
msgid "Remove project \"{0}\"?"
msgstr "Удалить проект «{0}»?"

#: src/components/settings/ConnectionsSettings.tsx:1253
msgid "Removing…"
msgstr "Удаление…"

#: src/components/Sidebar.tsx:1388
msgid "Rename"
msgstr "Переименовать"

#: src/components/Sidebar.tsx:1814
msgid "Rename project"
msgstr "Переименовать проект"

#: src/components/Sidebar.tsx:1574
msgid "Rename thread"
msgstr "Переименовать чат"

#: src/components/CommandPalette.tsx:309
#~ msgid "repository"
#~ msgstr "репозиторий"

#: src/environments/primary/auth.ts:197
msgid "Requested scope exceeds the bootstrap credential grant."
msgstr "Запрошенные права шире, чем выдано при подключении."

#: src/environments/primary/auth.ts:196
msgid "Requested token scope is invalid."
msgstr "Запрошенные права токена недействительны."

#: src/components/settings/SettingsPanels.tsx:332
msgid "Require a second click on the inline archive action before a thread is archived."
msgstr "Требовать повторное нажатие кнопки архивирования, прежде чем чат будет заархивирован."

#: src/components/settings/settingsLayout.tsx:108
msgid "Reset {label} to default"
msgstr "Сбросить {label} к значению по умолчанию"

#: src/components/settings/KeybindingsSettings.tsx:921
#: src/components/settings/settingsLayout.tsx:120
msgid "Reset to default"
msgstr "Сбросить к значению по умолчанию"

#: src/components/settings/DiagnosticsSettings.tsx:999
msgid "Resource History"
msgstr "История ресурсов"

#: src/components/settings/SettingsPanels.tsx:162
msgid "Restore default settings?"
msgstr "Восстановить настройки по умолчанию?"

#: src/routes/settings.tsx:28
msgid "Restore defaults"
msgstr "Восстановить значения по умолчанию"

#: src/components/WebSocketConnectionSurface.tsx:54
msgid "Retries exhausted trying to reconnect"
msgstr "Попытки переподключения исчерпаны"

#: src/components/chat/BasaDocumentDialog.tsx:238
#: src/components/WebSocketConnectionSurface.tsx:403
msgid "Retry"
msgstr "Повторить"

#: src/components/WebSocketConnectionSurface.tsx:421
msgid "Retry now"
msgstr "Повторить"

#: src/components/settings/ConnectionsSettings.tsx:495
msgid "Reusable"
msgstr "Многоразовая"

#: src/components/ChatView.tsx:1043
#~ msgid "Revert this thread to checkpoint {turnCount}?"
#~ msgstr "Откатить этот чат к контрольной точке {turnCount}?"

#: src/components/chat/MessagesTimeline.tsx:409
#: src/components/chat/MessagesTimeline.tsx:416
#~ msgid "Revert to this message"
#~ msgstr "Откатить к этому сообщению"

#: src/components/settings/ConnectionsSettings.tsx:684
#: src/components/settings/ConnectionsSettings.tsx:775
msgid "Revoke"
msgstr "Отозвать"

#: src/components/settings/ConnectionsSettings.tsx:682
#: src/components/settings/ConnectionsSettings.tsx:773
msgid "Revoking…"
msgstr "Отзыв…"

#: src/components/settings/DiagnosticsSettings.tsx:580
msgid "Root process {name}"
msgstr "Корневой процесс {name}"

#: src/components/chat/MessagesTimeline.tsx:1445
msgid "Rule"
msgstr "Правило"

#: src/components/chat/ChatComposer.tsx:557
msgid "Run provider command"
msgstr "Запустить команду провайдера"

#: src/components/chat/ChatComposer.tsx:575
msgid "Run provider skill"
msgstr "Запустить навык провайдера"

#: src/components/chat/taskStatusLabels.ts:9
msgid "running"
msgstr "выполняется"

#: src/components/chat/MessagesTimeline.tsx:947
msgid "Runtime error"
msgstr "Ошибка выполнения"

#: src/components/settings/DiagnosticsSettings.tsx:1022
msgid "Samples"
msgstr "Замеры"

#: src/components/settings/KeybindingsSettings.tsx:874
#: src/components/settings/KeybindingsSettings.tsx:1037
#: src/components/Sidebar.tsx:1850
msgid "Save"
msgstr "Сохранить"

#: src/environments/runtime/service.ts:1301
msgid "Saved environment credential expired. Pair it again."
msgstr "Срок действия учётных данных сохранённого окружения истёк. Подключите его заново."

#: src/environments/runtime/service.ts:1236
msgid "Saved environment is missing its saved credential."
msgstr "У сохранённого окружения нет учётных данных."

#: src/environments/runtime/service.ts:1233
msgid "Saved environment is missing its saved credential. Pair it again."
msgstr "У сохранённого окружения нет учётных данных. Подключите его заново."

#: src/environments/runtime/service.ts:1459
msgid "Saved environment not found."
msgstr "Сохранённое окружение не найдено."

#: src/components/settings/KeybindingsSettings.tsx:874
#: src/components/settings/KeybindingsSettings.tsx:1037
msgid "Saving"
msgstr "Сохранение"

#: src/components/chat/timelineAutoScroll.tsx:50
msgid "Scroll to bottom"
msgstr "Прокрутить вниз"

#: src/components/Sidebar.tsx:2219
msgid "Search"
msgstr "Поиск"

#: src/components/CommandPalette.logic.ts:272
msgid "Search commands, projects, and threads..."
msgstr "Поиск команд, проектов и чатов..."

#: src/components/DocumentsSidebar.tsx:821
msgid "Search documents"
msgstr "Поиск по документам"

#: src/components/settings/KeybindingsSettings.tsx:120
#: src/components/settings/KeybindingsSettings.tsx:127
#: src/components/settings/KeybindingsSettings.tsx:153
#: src/components/settings/KeybindingsSettings.tsx:154
msgid "Search keybindings"
msgstr "Поиск сочетаний клавиш"

#: src/components/chat/DraftProjectChip.tsx:148
msgid "Search projects..."
msgstr "Поиск проектов…"

#: src/components/CommandPalette.logic.ts:274
msgid "Search..."
msgstr "Поиск..."

#: src/components/chat/MessagesTimeline.tsx:932
msgid "Searched files"
msgstr "Поиск по файлам"

#: src/components/chat/ComposerCommandMenu.tsx:163
msgid "Searching workspace files..."
msgstr "Поиск файлов рабочей области..."

#: src/components/chat/ComposerCommandMenu.tsx:155
msgid "Searching workspace skills..."
msgstr "Поиск навыков рабочей области..."

#: src/components/CommandPalette.tsx:292
msgid "select"
msgstr "выбрать"

#: src/components/CommandPalette.tsx:440
#: src/components/DocumentsSidebar.tsx:883
msgid "Select"
msgstr "Выбрать"

#: src/components/chat/DraftProjectChip.tsx:114
msgid "Select a project"
msgstr "Выбрать проект"

#: src/components/DocumentsSidebar.tsx:498
msgid "Select all files"
msgstr "Выбрать все файлы"

#: src/components/NoActiveThreadState.tsx:25
msgid "Select an existing thread or create a new one to get started."
msgstr "Выберите существующий чат или создайте новый, чтобы начать."

#: src/components/settings/ConnectionsSettings.tsx:930
msgid "Select at least one permission."
msgstr "Выберите хотя бы одно разрешение."

#: src/components/DocumentsSidebar.tsx:498
msgid "Select file"
msgstr "Выбрать файл"

#: src/components/chat/DraftProjectChip.tsx:139
msgid "Select project"
msgstr "Выбор проекта"

#: src/components/chat/MessagesTimeline.tsx:281
msgid "Send a message to start the conversation."
msgstr "Отправьте сообщение, чтобы начать разговор."

#: src/components/chat/ChatComposer.tsx:632
#: src/components/chat/ComposerPrimaryActions.tsx:93
msgid "Send message"
msgstr "Отправить сообщение"

#: src/components/settings/DiagnosticsSettings.tsx:380
msgid "Send SIGINT"
msgstr "Отправить SIGINT"

#: src/components/settings/DiagnosticsSettings.tsx:397
msgid "Send SIGKILL"
msgstr "Отправить SIGKILL"

#: src/components/settings/DiagnosticsSettings.tsx:884
msgid "Send SIGKILL to process {pid}? This cannot be handled by the process."
msgstr "Отправить SIGKILL процессу {pid}? Процесс не может это обработать."

#: src/components/chat/ComposerPrimaryActions.tsx:92
msgid "Sending"
msgstr "Отправка"

#: src/components/ChatView.tsx:518
msgid "server"
msgstr "сервер"

#: src/components/settings/DiagnosticsSettings.tsx:966
msgid "Server PID"
msgstr "PID сервера"

#: src/components/settings/InspectSettings.tsx:34
#: src/components/settings/InspectSettings.tsx:40
#~ msgid "Service steps"
#~ msgstr "Служебные шаги"

#: src/components/CommandPalette.tsx:318
msgid "settings"
msgstr "настройки"

#: src/components/Sidebar.tsx:2108
#: src/routes/settings.tsx:70
msgid "Settings"
msgstr "Настройки"

#: src/components/chat/MessagesTimeline.tsx:1326
msgid "Shell command"
msgstr "Команда в shell"

#: src/components/chat/ChatComposer.tsx:131
#: src/components/chat/CompactComposerControlsMenu.tsx:61
msgid "Show {planSidebarLabel} sidebar"
msgstr "Показать боковую панель {planSidebarLabel}"

#: src/components/settings/ConnectionsSettings.tsx:620
msgid "Show code"
msgstr "Показать код"

#: src/routes/__root.tsx:212
msgid "Show error details"
msgstr "Показать подробности ошибки"

#: src/components/settings/DiagnosticsSettings.tsx:187
msgid "Show full error"
msgstr "Показать полную ошибку"

#: src/components/chat/MessagesTimeline.tsx:804
#: src/components/settings/DiagnosticsSettings.tsx:1268
msgid "Show full message"
msgstr "Показать полное сообщение"

#: src/components/chat/MessagesTimeline.tsx:804
#: src/components/settings/DiagnosticsSettings.tsx:187
#: src/components/Sidebar.tsx:673
msgid "Show less"
msgstr "Показать меньше"

#: src/components/settings/ConnectionsSettings.tsx:620
msgid "Show link"
msgstr "Показать ссылку"

#: src/components/Sidebar.tsx:655
msgid "Show more"
msgstr "Показать больше"

#: src/components/settings/ConnectionsSettings.tsx:543
msgid "Show QR code"
msgstr "Показать QR-код"

#: src/components/chat/MessagesTimeline.tsx:1110
msgid "Show raw details"
msgstr "Показать сырые данные"

#: src/components/WebSocketConnectionSurface.tsx:523
msgid "Show requests"
msgstr "Показать запросы"

#: src/components/settings/ConnectionsSettings.tsx:453
msgid "Showing the full value instead."
msgstr "Вместо этого показывается полное значение."

#: src/components/Sidebar.tsx:1931
msgid "Sidebar options"
msgstr "Параметры боковой панели"

#: src/components/DocumentsSidebar.tsx:555
#: src/components/DocumentsSidebar.tsx:624
msgid "Size"
msgstr "Размер"

#: src/components/chat/ComposerCommandMenu.tsx:77
#: src/components/chat/ComposerCommandMenu.tsx:151
msgid "Skills"
msgstr "Навыки"

#: src/components/settings/DiagnosticsSettings.tsx:1083
msgid "Slow Spans"
msgstr "Медленные спаны"

#: src/components/settings/DiagnosticsSettings.tsx:1184
msgid "Slowest Spans"
msgstr "Самые медленные спаны"

#: src/components/WebSocketConnectionSurface.tsx:527
msgid "Some requests are slow"
msgstr "Некоторые запросы выполняются медленно"

#: src/components/settings/KeybindingsSettings.tsx:1242
msgid "Some shortcuts may be claimed by the browser before {APP_BASE_NAME} sees them."
msgstr "Некоторые сочетания клавиш могут перехватываться браузером до того, как их увидит {APP_BASE_NAME}."

#. placeholder {0}: traceDiagnosticsError.message
#: src/components/settings/DiagnosticsSettings.tsx:1112
msgid "Some trace files could not be read, so diagnostics may be incomplete. {0}"
msgstr "Некоторые файлы трейсов не удалось прочитать, поэтому диагностика может быть неполной. {0}"

#: src/routes/__root.tsx:196
msgid "Something went wrong."
msgstr "Что-то пошло не так."

#: src/timestampFormat.ts:106
msgid "Soon"
msgstr "Скоро"

#: src/components/Sidebar.tsx:1937
msgid "Sort projects"
msgstr "Сортировать проекты"

#: src/components/Sidebar.tsx:1958
msgid "Sort threads"
msgstr "Сортировать чаты"

#: src/components/settings/DiagnosticsSettings.tsx:1129
#: src/components/settings/DiagnosticsSettings.tsx:1157
#: src/components/settings/DiagnosticsSettings.tsx:1187
#: src/components/settings/DiagnosticsSettings.tsx:1238
#: src/components/settings/DiagnosticsSettings.tsx:1290
msgid "Span"
msgstr "Спан"

#: src/components/settings/DiagnosticsSettings.tsx:1213
msgid "Span Logs"
msgstr "Логи спана"

#: src/components/settings/DiagnosticsSettings.tsx:1076
msgid "Spans"
msgstr "Спаны"

#: src/components/settings/DiagnosticsSettings.tsx:1088
msgid "Spans at or above the configured slow-span threshold."
msgstr "Спаны на уровне или выше настроенного порога медленных спанов."

#. placeholder {0}: formatDuration(data.slowSpanThresholdMs)
#: src/components/settings/DiagnosticsSettings.tsx:1087
msgid "Spans with a duration of {0} or longer."
msgstr "Спаны длительностью {0} или дольше."

#: src/components/settings/ConnectionsSettings.tsx:901
msgid "Standard"
msgstr "Стандартный"

#: src/components/settings/ConnectionsSettings.tsx:112
msgid "Start tasks and perform changes in the environment."
msgstr "Запускайте задачи и вносите изменения в окружении."

#: src/components/chat/MessagesTimeline.tsx:1476
msgid "Started"
msgstr "Начало"

#. placeholder {0}: formatConnectionMoment(req.startedAt) ?? req.startedAt
#: src/components/WebSocketConnectionSurface.tsx:110
msgid "Started {0}"
msgstr "Начато {0}"

#: src/components/chat/MessagesTimeline.tsx:1471
#: src/components/DocumentsSidebar.tsx:526
#: src/components/settings/KeybindingsSettings.tsx:1265
msgid "Status"
msgstr "Статус"

#: src/components/chat/MessagesTimeline.tsx:1371
msgid "Step"
msgstr "Шаг"

#: src/components/PlanSidebar.tsx:100
msgid "Steps"
msgstr "Шаги"

#: src/components/settings/InspectSettings.tsx:35
#~ msgid "Steps meant for developers and provider warnings. Off, they stay hidden as they are for a user."
#~ msgstr "Шаги для разработчиков и предупреждения провайдера. Выключено: скрыты, как и у пользователя."

#: src/components/chat/ComposerPrimaryActions.tsx:57
msgid "Stop generation"
msgstr "Остановить генерацию"

#: src/components/chat/ComposerVoiceButton.tsx:59
msgid "Stop recording"
msgstr "Остановить запись"

#: src/components/chat/ComposerPrimaryActions.tsx:57
msgid "Stop upload"
msgstr "Остановить загрузку"

#: src/components/chat/taskStatusLabels.ts:13
msgid "stopped"
msgstr "остановлено"

#: src/components/chat/MessagesTimeline.tsx:937
msgid "Subagent task"
msgstr "Задача агента"

#: src/components/settings/DiagnosticsSettings.tsx:303
msgid "Subprocess"
msgstr "Подпроцесс"

#: src/components/settings/SettingsPanels.tsx:88
msgid "Switches the hosted app release channel."
msgstr "Переключает канал релизов веб-версии приложения."

#: src/components/settings/SettingsPanels.tsx:47
#: src/components/settings/SettingsPanels.tsx:214
msgid "System"
msgstr "Системная"

#: src/components/settings/SettingsPanels.tsx:60
msgid "System default"
msgstr "Системное значение"

#: src/components/settings/SettingsPanels.tsx:262
msgid "System default follows your browser or OS clock preference."
msgstr "Системное значение следует настройкам часов вашего браузера или ОС."

#: src/components/chat/ChatComposer.tsx:610
#: src/components/PlanSidebar.tsx:48
msgid "Tasks"
msgstr "Задачи"

#: src/components/settings/CapabilitiesSettings.tsx:153
msgid "Team flag file"
msgstr "Файл флагов команды"

#: src/components/chat/ThreadErrorBanner.tsx:18
msgid "The agent could not complete the request. Contact your administrator if this persists."
msgstr "Агенту не удалось выполнить запрос. Если проблема не исчезнет, обратитесь к администратору."

#: src/components/chat/ProviderStatusBanner.tsx:19
msgid "The agent has limited availability"
msgstr "Агент работает с ограничениями"

#: src/components/chat/ProviderStatusBanner.tsx:21
msgid "The agent is not signed in"
msgstr "Агент не авторизован"

#: src/components/chat/ProviderStatusBanner.tsx:22
msgid "The agent is unavailable"
msgstr "Агент недоступен"

#. placeholder {0}: error.requiredScope
#: src/environments/primary/auth.ts:199
msgid "The authenticated token is missing required scope: {0}."
msgstr "У аутентифицированного токена нет требуемого права: {0}."

#. placeholder {0}: model.model
#: src/components/settings/CapabilitiesSettings.tsx:219
msgid "The Codex instance does not offer the configured model <0>{0}</0>."
msgstr "Экземпляр Codex не предлагает настроенную модель <0>{0}</0>."

#: src/components/chat/ContextWindowMeter.tsx:128
#~ msgid "The context is compacted automatically when needed."
#~ msgstr "Контекст сжимается автоматически при необходимости."

#: src/components/chat/BasaDocumentDialog.tsx:206
msgid "The document address is invalid."
msgstr "Неверный адрес документа."

#: src/components/settings/CapabilitiesSettings.tsx:122
msgid "The feature flag file was not updated."
msgstr "Файл флагов возможностей не обновлён."

#: src/components/settings/KeybindingsSettings.tsx:1169
msgid "The keybinding was not removed."
msgstr "Сочетание клавиш не было удалено."

#: src/components/settings/KeybindingsSettings.tsx:1149
msgid "The keybinding was not saved."
msgstr "Сочетание клавиш не было сохранено."

#: src/components/chat/BasaDocumentDialog.tsx:202
msgid "The legal database is temporarily unavailable. Try again later."
msgstr "База временно недоступна. Попробуйте позже."

#: src/components/settings/ConnectionsSettings.tsx:1025
msgid "The link and its devices stay valid until the link is revoked."
msgstr "Ссылка и её устройства работают до отзыва ссылки."

#. placeholder {0}: accessTimestampFormatter.format( new Date(Date.now() + pairingTtlDays * SECONDS_PER_DAY * 1000), )
#: src/components/settings/ConnectionsSettings.tsx:1026
msgid "The link and its devices will expire on {0}."
msgstr "Ссылка и её устройства истекут {0}."

#: src/components/settings/KeybindingsSettings.tsx:286
msgid "The most recent matching binding wins when both conditions can apply."
msgstr "Когда применимы оба условия, побеждает последняя подходящая привязка."

#: src/components/settings/DiagnosticsSettings.tsx:900
msgid "The process is not a child of the {APP_SERVER_NAME}. It might already have exited."
msgstr "Процесс не является потомком {APP_SERVER_NAME}. Возможно, он уже завершён."

#: src/components/chat/DraftProjectChip.tsx:103
msgid "The project for this draft is unavailable. Pick a project to send."
msgstr "Проект этого черновика недоступен. Выберите проект, чтобы отправить сообщение."

#: src/components/settings/CapabilitiesSettings.tsx:92
msgid "The server did not answer."
msgstr "Сервер не ответил."

#: src/components/settings/CapabilitiesSettings.tsx:157
msgid "The team flag file is invalid; the last valid values stay in force until it is fixed or the next change here rewrites it."
msgstr "Файл флагов команды повреждён; действуют последние корректные значения, пока файл не исправят или следующее изменение здесь не перезапишет его."

#: src/components/settings/CapabilitiesSettings.tsx:211
msgid "The team model value is invalid; the image value applies."
msgstr "Значение модели команды некорректно; действует значение из образа."

#: src/components/settings/CapabilitiesSettings.tsx:188
msgid "The team value is invalid; the image value applies."
msgstr "Значение команды некорректно; действует значение из образа."

#: src/components/settings/SettingsPanels.tsx:199
msgid "theme"
msgstr "тема"

#: src/components/settings/SettingsPanels.tsx:127
#: src/components/settings/SettingsPanels.tsx:195
msgid "Theme"
msgstr "Тема"

#: src/components/settings/SettingsPanels.tsx:211
msgid "Theme preference"
msgstr "Настройка темы"

#: src/components/chat/MessagesTimeline.tsx:600
msgid "Thinking"
msgstr "Думаю"

#: src/components/chat/MessagesTimeline.tsx:565
#~ msgid "Thinking about the next step"
#~ msgstr "Обдумываю следующий шаг"

#: src/components/Sidebar.tsx:1118
msgid "This action cannot be undone."
msgstr "Это действие нельзя отменить."

#: src/components/settings/ConnectionsSettings.tsx:1628
msgid "This backend is already configured for remote access. Network exposure changes must be made where the server is launched."
msgstr "Этот сервер уже доступен по сети. Настройки сетевого доступа меняются там, где он запущен."

#: src/components/settings/ConnectionsSettings.tsx:1629
msgid "This backend is only reachable on this machine. Restart it with a non-loopback host to enable remote pairing."
msgstr "Этот сервер доступен только с этой машины. Перезапустите его на не-loopback хосте, чтобы разрешить подключение по сети."

#: src/components/settings/ConnectionsSettings.tsx:934
msgid "This client can create or revoke access for other devices."
msgstr "Этот клиент может создавать или отзывать доступ для других устройств."

#: src/components/settings/ConnectionsSettings.tsx:750
#: src/environmentOptions.ts:32
msgid "This device"
msgstr "Это устройство"

#: src/components/settings/ConnectionsSettings.tsx:1659
#: src/components/settings/ConnectionsSettings.tsx:1688
msgid "This environment"
msgstr "Это окружение"

#: src/components/auth/PairingRouteSurface.tsx:183
msgid "This one-time pairing token was already submitted. Request a new pairing link."
msgstr "Этот одноразовый токен уже был использован. Запросите новую ссылку для подключения."

#: src/environments/primary/auth.ts:201
msgid "This operation is not allowed for the current session."
msgstr "Эта операция недоступна для текущей сессии."

#: src/components/StaleClientToastCoordinator.tsx:41
msgid "This page is out of date"
msgstr "Страница устарела"

#: src/environments/primary/auth.ts:192
msgid "This pairing link has already been used on all of its devices. Request a new one."
msgstr "Эта ссылка уже использована на всех своих устройствах. Запросите новую."

#: src/components/auth/PairingRouteSurface.tsx:165
#: src/components/auth/PairingRouteSurface.tsx:176
msgid "This pairing link is missing its backend host or token."
msgstr "В этой ссылке для подключения отсутствует хост сервера или токен."

#: src/components/Sidebar.tsx:1285
msgid "This permanently clears conversation history for these threads."
msgstr "Это безвозвратно очистит историю разговоров для этих чатов."

#: src/components/Sidebar.tsx:1661
msgid "This permanently clears conversation history for this thread."
msgstr "Это безвозвратно очистит историю разговоров для этого чата."

#: src/components/Sidebar.tsx:1116
msgid "This permanently clears conversation history for those threads."
msgstr "Это безвозвратно очистит историю разговоров для тех чатов."

#: src/components/Sidebar.tsx:1117
#: src/components/Sidebar.tsx:1126
#: src/components/Sidebar.tsx:1161
msgid "This removes only this project entry."
msgstr "Это удалит только эту запись проекта."

#: src/components/SubAgentListView.tsx:56
msgid "This thread has not started any agents yet"
msgstr "В этом чате ещё не было агентов"

#: src/components/ChatView.tsx:1044
#~ msgid "This will discard newer messages and turn diffs in this thread."
#~ msgstr "Более новые сообщения и диффы в этом чате будут отброшены."

#: src/components/settings/SettingsPanels.tsx:162
msgid "This will reset: {changedList}."
msgstr "Будет сброшено: {changedList}."

#: src/components/Sidebar.tsx:747
msgid "Thread ID copied"
msgstr "ID чата скопирован"

#: src/components/Sidebar.tsx:1471
msgid "Thread title cannot be empty"
msgstr "Название чата не может быть пустым"

#: src/components/settings/KeybindingsSettings.logic.ts:290
msgid "Thread: Jump {slot}"
msgstr "Чат: перейти к {slot}"

#: src/components/settings/KeybindingsSettings.logic.ts:269
msgid "Thread: Next"
msgstr "Чат: следующий"

#: src/components/settings/KeybindingsSettings.logic.ts:267
msgid "Thread: Previous"
msgstr "Чат: предыдущий"

#: src/components/CommandPalette.logic.ts:215
msgid "Threads"
msgstr "Чаты"

#: src/components/settings/DiagnosticsSettings.tsx:1232
msgid "Time"
msgstr "Время"

#: src/components/settings/SettingsPanels.tsx:266
msgid "time format"
msgstr "формат времени"

#: src/components/settings/SettingsPanels.tsx:130
#: src/components/settings/SettingsPanels.tsx:261
msgid "Time format"
msgstr "Формат времени"

#: src/environments/primary/auth.ts:250
msgid "Timed out waiting for authenticated session after bootstrap."
msgstr "Истекло время ожидания аутентифицированной сессии после подключения."

#: src/components/settings/SettingsPanels.tsx:284
msgid "Timestamp format"
msgstr "Формат отметки времени"

#: src/components/settings/UsageSettings.tsx:120
msgid "Tokens, M"
msgstr "Токены, млн"

#: src/environments/primary/auth.ts:190
msgid "Too many pairing attempts. Wait a few minutes and try again."
msgstr "Слишком много попыток подключения. Подождите несколько минут и попробуйте ещё раз."

#: src/components/chat/MessagesTimeline.tsx:938
#: src/components/chat/MessagesTimeline.tsx:1461
#: src/components/chat/MessagesTimeline.tsx:1467
msgid "Tool"
msgstr "Инструмент"

#: src/components/chat/MessagesTimeline.tsx:936
msgid "Tool call"
msgstr "Вызов инструмента"

#: src/components/chat/MessagesTimeline.tsx:955
msgid "Tool updated"
msgstr "Инструмент обновлён"

#: src/components/settings/DiagnosticsSettings.tsx:1287
msgid "Top Span Names"
msgstr "Основные имена спанов"

#: src/components/settings/UsageSettings.tsx:155
msgid "Total"
msgstr "Итого"

#: src/components/DocumentsSidebar.tsx:710
msgid "Total {total}"
msgstr "Всего {total}"

#: src/components/settings/DiagnosticsSettings.tsx:958
msgid "Total CPU across live child processes of the current server process."
msgstr "Суммарное ЦП по активным дочерним процессам текущего процесса сервера."

#: src/components/chat/ContextWindowMeter.tsx:119
#~ msgid "Total processed"
#~ msgstr "Всего обработано"

#: src/components/settings/DiagnosticsSettings.tsx:963
msgid "Total resident memory across live child processes of the current server process."
msgstr "Суммарная резидентная память по активным дочерним процессам текущего процесса сервера."

#: src/components/settings/DiagnosticsSettings.tsx:1187
#: src/components/settings/DiagnosticsSettings.tsx:1244
msgid "Trace"
msgstr "Трейс"

#: src/components/settings/DiagnosticsSettings.tsx:1063
msgid "Trace Diagnostics"
msgstr "Диагностика трейсов"

#: src/components/chat/ComposerVoiceRecordingBar.tsx:48
msgid "Transcribing"
msgstr "Распознавание"

#: src/components/auth/PairingRouteSurface.tsx:270
#: src/routes/__root.tsx:202
msgid "Try again"
msgstr "Попробовать снова"

#: src/components/chat/ChatComposer.tsx:1119
msgid "Try again."
msgstr "Попробуйте ещё раз."

#: src/components/chat/TurnInspectionButton.tsx:67
msgid "Turn details"
msgstr "Параметры хода"

#: src/components/chat/MessagesTimeline.tsx:1443
#: src/components/settings/DiagnosticsSettings.tsx:483
msgid "Type"
msgstr "Тип"

#: src/components/settings/CapabilitiesSettings.tsx:91
msgid "Unable to load capabilities"
msgstr "Не удалось загрузить возможности"

#: src/environments/runtime/service.ts:1538
msgid "Unable to persist saved environment credentials."
msgstr "Не удалось сохранить учётные данные сохранённого окружения."

#: src/components/settings/KeybindingsSettings.tsx:1167
msgid "Unable to remove keybinding"
msgstr "Не удалось удалить сочетание клавиш"

#: src/environments/runtime/service.ts:1176
msgid "Unable to resolve the primary environment."
msgstr "Не удалось определить основное окружение."

#: src/components/WebSocketConnectionSurface.tsx:244
msgid "Unable to restart the WebSocket."
msgstr "Не удалось перезапустить WebSocket."

#: src/components/CommandPalette.tsx:363
msgid "Unable to run command"
msgstr "Не удалось выполнить команду"

#: src/components/settings/KeybindingsSettings.tsx:1148
msgid "Unable to save keybinding"
msgstr "Не удалось сохранить сочетание клавиш"

#: src/components/settings/CapabilitiesSettings.tsx:120
msgid "Unable to update capability"
msgstr "Не удалось изменить возможность"

#: src/components/settings/SettingsPanels.tsx:463
#: src/components/settings/SettingsPanels.tsx:570
msgid "Unarchive"
msgstr "Разархивировать"

#: src/components/settings/KeybindingsSettings.tsx:856
#: src/components/settings/KeybindingsSettings.tsx:1021
msgid "Unassigned"
msgstr "Не назначено"

#: src/components/Sidebar.tsx:1583
msgid "Unblock chat"
msgstr "Разблокировать чат"

#. placeholder {0}: identifiers[0]
#: src/components/settings/KeybindingsSettings.tsx:235
msgid "Unknown condition: {0}"
msgstr "Неизвестное условие: {0}"

#. placeholder {0}: identifiers.join(", ")
#: src/components/settings/KeybindingsSettings.tsx:236
msgid "Unknown conditions: {0}"
msgstr "Неизвестные условия: {0}"

#: src/components/Sidebar.tsx:1136
#: src/components/Sidebar.tsx:1171
msgid "Unknown error removing project."
msgstr "Неизвестная ошибка при удалении проекта."

#: src/components/DocumentsSidebar.tsx:493
msgid "Unsupported"
msgstr "Не поддерж."

#. placeholder {0}: pairingLink.maxUses
#: src/components/settings/ConnectionsSettings.tsx:498
msgid "Up to {0} devices"
msgstr "До {0} устройств"

#: src/components/Sidebar.tsx:1819
msgid "Update the project title."
msgstr "Обновите название проекта."

#. placeholder {0}: projectRenameTarget.cwd
#: src/components/Sidebar.tsx:1818
msgid "Update the title for {0}."
msgstr "Обновите название для {0}."

#: src/components/settings/SettingsPanels.tsx:87
#: src/components/settings/SettingsPanels.tsx:99
msgid "Update track"
msgstr "Канал обновлений"

#: src/components/ChatView.logic.ts:158
msgid "Uploading {currentFile}/{totalFiles} files · {percent}%"
msgstr "Загрузка {currentFile}/{totalFiles} файлов · {percent}%"

#: src/components/ChatView.logic.ts:160
msgid "Uploading… {percent}%"
msgstr "Загрузка… {percent}%"

#: src/components/settings/settingsNavItems.ts:34
msgid "Usage"
msgstr "Расход"

#. placeholder {0}: pairingLink.useCount
#. placeholder {1}: pairingLink.maxUses
#: src/components/settings/ConnectionsSettings.tsx:502
msgid "Used {0} of {1}"
msgstr "Использована {0} из {1}"

#. placeholder {0}: pairingLink.useCount
#: src/components/settings/ConnectionsSettings.tsx:501
msgid "Used {0}×"
msgstr "Использована {0}×"

#: src/components/settings/CapabilitiesSettings.tsx:168
msgid "User capabilities"
msgstr "Возможности пользователей"

#: src/components/chat/MessagesTimeline.tsx:949
msgid "User input requested"
msgstr "Запрошен ввод пользователя"

#: src/components/chat/MessagesTimeline.tsx:950
msgid "User input submitted"
msgstr "Ввод пользователя отправлен"

#: src/components/chat/UserMessageRail.tsx:166
msgid "User messages"
msgstr "Сообщения пользователя"

#: src/components/auth/PairingRouteSurface.tsx:34
msgid "Validating the pairing link and preparing your session."
msgstr "Проверка ссылки для подключения и подготовка сессии."

#: src/components/settings/InspectSettings.tsx:23
#: src/components/settings/InspectSettings.tsx:29
msgid "Verbose output"
msgstr "Подробный вывод"

#: src/components/auth/PairingRouteSurface.tsx:256
msgid "Verify the backend is reachable from this browser, supports CORS for hosted clients, and is served over HTTPS when opening this page from HTTPS."
msgstr "Убедитесь, что сервер доступен из этого браузера, поддерживает CORS для веб-клиентов и обслуживается по HTTPS при открытии этой страницы по HTTPS."

#: src/components/settings/SettingsPanels.tsx:69
msgid "Version"
msgstr "Версия"

#: src/components/settings/ConnectionsSettings.tsx:1662
msgid "Version drift"
msgstr "Расхождение версий"

#. placeholder {0}: versionMismatch.clientVersion
#. placeholder {1}: versionMismatch.serverVersion
#: src/components/settings/ConnectionsSettings.tsx:1218
msgid "Version drift: client {0}, server {1}."
msgstr "Расхождение версий: клиент {0}, сервер {1}."

#: src/versionSkew.ts:49
msgid "Version mismatch. Try syncing the client and server to the same {APP_BASE_NAME} version."
msgstr "Несовпадение версий. Попробуйте синхронизировать клиент и сервер до одной версии {APP_BASE_NAME}."

#: src/components/settings/ConnectionsSettings.tsx:121
msgid "View access"
msgstr "Просмотр доступа"

#: src/components/settings/ConnectionsSettings.tsx:106
msgid "View environment"
msgstr "Посмотреть окружение"

#: src/components/Sidebar.tsx:1983
#: src/components/Sidebar.tsx:1998
msgid "Visible thread count"
msgstr "Число видимых чатов"

#: src/components/settings/SettingsPanels.tsx:133
#: src/components/Sidebar.tsx:1979
msgid "Visible threads"
msgstr "Видимые чаты"

#: src/components/chat/ComposerVoiceButton.tsx:73
#: src/components/chat/ComposerVoiceButton.tsx:88
#: src/components/settings/CapabilitiesSettings.tsx:49
msgid "Voice input"
msgstr "Голосовой ввод"

#: src/components/chat/ComposerVoiceButton.tsx:72
msgid "Voice input is not supported in this browser"
msgstr "Голосовой ввод не поддерживается в этом браузере"

#: src/components/chat/MessagesTimeline.tsx:607
msgid "Waiting for helpers"
msgstr "Жду результаты помощников"

#: src/components/chat/MessagesTimeline.tsx:933
#: src/components/chat/MessagesTimeline.tsx:1330
msgid "Web search"
msgstr "Веб-поиск"

#: src/components/settings/KeybindingsSettings.tsx:641
#: src/components/settings/KeybindingsSettings.tsx:1262
msgid "When"
msgstr "Когда"

#: src/components/settings/KeybindingsSettings.tsx:675
msgid "When expression"
msgstr "Выражение when"

#: src/components/settings/ConnectionsSettings.tsx:990
msgid "When it ends, the link and every device paired with it stop working."
msgstr "По истечении срока ссылка и все подключённые по ней устройства перестают работать."

#: src/components/chat/MessagesTimeline.tsx:441
msgid "Work log"
msgstr "Журнал работы"

#: src/components/chat/MessagesTimeline.tsx:441
msgid "Worked for {elapsed}"
msgstr "Работал {elapsed}"

#: src/components/chat/taskStatusLabels.ts:10
msgid "working"
msgstr "работает"

#: src/components/Sidebar.logic.ts:36
msgid "Working"
msgstr "Выполняется"

#: src/components/chat/MessagesTimeline.tsx:671
msgid "Working for <0/>"
msgstr "Выполняется <0/>"

#: src/components/chat/MessagesTimeline.tsx:675
msgid "Working..."
msgstr "Выполняется..."

#: src/components/ChatMarkdown.tsx:504
msgid "Wrap lines"
msgstr "Переносить строки"

#: src/components/settings/ConnectionsSettings.tsx:116
msgid "Write reviews"
msgstr "Писать ревью"

#: src/components/chat/ChatComposer.tsx:1262
msgid "You can attach up to {PROVIDER_SEND_TURN_MAX_ATTACHMENTS} files per message."
msgstr "Вы можете прикрепить до {PROVIDER_SEND_TURN_MAX_ATTACHMENTS} файлов на сообщение."

#: src/components/chat/BasaDocumentDialog.tsx:204
msgid "Your session has expired. Reload the page."
msgstr "Сессия истекла. Обновите страницу."

#: src/components/auth/PairingRouteSurface.tsx:133
msgid "Your token"
msgstr "Ваш токен"

#: src/components/auth/PairingRouteSurface.tsx:133
msgid "Your token, e.g. 7K9M2P4R8T6W"
msgstr "Ваш токен, типа 7K9M2P4R8T6W"
